var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Polyfills

/**
 * Promise polyfill
 * @see https://github.com/taylorhakes/promise-polyfill
 */
// Promise Collapsible Group
(function (global, factory) {
  if (!global.Promise) {
    global.Promise = factory();
  }
})(window, function () {
  'use strict';

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())

  var setTimeoutFunc = setTimeout;

  function noop() {}

  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && ((typeof newValue === 'undefined' ? 'undefined' : _typeof(newValue)) === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function () {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  function Promise(fn) {
    if (!(this instanceof Promise)) throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  var _proto = Promise.prototype;
  _proto.catch = function (onRejected) {
    return this.then(null, onRejected);
  };

  _proto.then = function (onFulfilled, onRejected) {
    var prom = new this.constructor(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    return new Promise(function (resolve, reject) {
      if (!arr || typeof arr.length === 'undefined') throw new TypeError('Promise.all accepts an array');
      var args = Array.prototype.slice.call(arr);
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = typeof setImmediate === 'function' && function (fn) {
    setImmediate(fn);
  } || function (fn) {
    setTimeoutFunc(fn, 0);
  };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  return Promise;
});
// /Promise Collapsible Group

//*
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}
//*/

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    }
  });
}
// Utility JavaScript functions
// Comment-out switches are wrapped around each block
// Use them to turn on/off specific utilities

/**
 * Force a repaint of a specific DOM Node
 * @param  {DOMElement} node A native DOM element to repaint.
 *                           Not jQuery, use $element.get(0) to convert.
 */
var repaint = function repaint(node) {
  node.style.display = 'none';
  node.offsetHeight; // jshint ignore:line
  node.style.display = '';
};

/**
 * Get a random integer between min and max.
 * @param  {Number} min The minimum integer to return.
 * @param  {Number} max The maximum integer to return.
 * @return {Number}
 */
var randBetween = function randBetween(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

/**
 * Get the true window width, without scrollbars.
 * @return integer The window width in px.
 */
//*
function windowWidth() {
  // Temporarily disable scrollbar
  jQuery('body').css({
    overflow: 'hidden'
  });

  // Get window width
  var w = jQuery(window).width();

  // Remove styles
  jQuery('body').css({
    overflow: ''
  });

  return w;
}
//*/

/**
 * Check if an element has been scrolled past, 
 * i.e. it is on screen or above the viewport.
 * @param  {jQuery}  $element The element to check.
 * @return {Boolean}          
 */
function hasBeenScrolledPast($element) {
  var elementTop = $element.offset().top,
      screenTop = jQuery(window).scrollTop(),
      screenBottom = screenTop + jQuery(window).outerHeight();

  return screenBottom >= elementTop;
}

/**
 * Return the amount of the element's height relative to the viewport height.
 * @param  {jQuery} $element The element to check. 
 * @return {Number} A number between 0 and 1.
 */
//*
function percentInViewport($element) {
  var elH = $element.outerHeight(),
      H = $(window).height(),
      r = $element[0].getBoundingClientRect(),
      t = r.top,
      b = r.bottom,
      pxInViewport = Math.max(0, t > 0 ? Math.min(elH, H - t) : Math.min(b, H));

  return elH < H ? 1 : pxInViewport / H;
}
// */

/**
 * Returns a function that will be called at most every N milliseconds.
 */
//*
function throttle(fn, threshold, scope) {
  threshold = threshold || 250;
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}
//*/

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
//*
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
//*/

/**
 * Create an XHR request wrapped in a Promise interface.
 * @param {Object} options An object containing at least method and url keys.
 *                         Optionally data and headers keys can be passed as well.
 *                         -
 *                         {String} method    The HTTP method to make the request with.
 *                         {String} url       The URL to send the request to.
 *                         {Object} [data]    An object containing parameters for the request. 
 *                         {Object} [headers] An object containing HTTP headers. Each object
 *                                            key should be the header name wrapped as a string.
 * @return {Promise}       A Promise object which is resolved when the request
 *                         returns and rejected when it errors.
 */
//*
var makeRequest = function makeRequest(options) {
  return new Promise(function (resolve, reject) {

    var xhr = new XMLHttpRequest();

    xhr.open(options.method, options.url);

    if (options.headers) {
      Object.keys(options.headers).forEach(function (key) {
        return xhr.setRequestHeader(key, options.headers[key]);
      });
    }

    xhr.onload = function () {
      resolve(xhr.response);
    };

    xhr.onerror = function () {
      reject(xhr);
    };

    // url encode form data for sending as post data
    var encodedData = options.data ? Object.keys(options.data).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(options.data[key]);
    }).join('&') : null;

    xhr.send(encodedData);
  });
};
//*/
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/

;(function (factory) {
    // eslint-disable-line no-extra-semi
    'use strict';

    if (typeof define === 'function' && define.amd) {
        // AMD
        define(['jquery'], factory);
    } else if (typeof module !== 'undefined' && module.exports) {
        // CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Global
        factory(jQuery);
    }
})(function ($) {
    /*
    *  internal
    */

    var _previousResizeWidth = -1,
        _updateTimeout = -1;

    /*
    *  _parse
    *  value parse utility function
    */

    var _parse = function _parse(value) {
        // parse value and convert NaN to 0
        return parseFloat(value) || 0;
    };

    /*
    *  _rows
    *  utility function returns array of jQuery selections representing each row
    *  (as displayed after float wrapping applied by browser)
    */

    var _rows = function _rows(elements) {
        var tolerance = 1,
            $elements = $(elements),
            lastTop = null,
            rows = [];

        // group elements by their top position
        $elements.each(function () {
            var $that = $(this),
                top = $that.offset().top - _parse($that.css('margin-top')),
                lastRow = rows.length > 0 ? rows[rows.length - 1] : null;

            if (lastRow === null) {
                // first item on the row, so just push it
                rows.push($that);
            } else {
                // if the row top is the same, add to the row group
                if (Math.floor(Math.abs(lastTop - top)) <= tolerance) {
                    rows[rows.length - 1] = lastRow.add($that);
                } else {
                    // otherwise start a new row group
                    rows.push($that);
                }
            }

            // keep track of the last row top
            lastTop = top;
        });

        return rows;
    };

    /*
    *  _parseOptions
    *  handle plugin options
    */

    var _parseOptions = function _parseOptions(options) {
        var opts = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };

        if ((typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            return $.extend(opts, options);
        }

        if (typeof options === 'boolean') {
            opts.byRow = options;
        } else if (options === 'remove') {
            opts.remove = true;
        }

        return opts;
    };

    /*
    *  matchHeight
    *  plugin definition
    */

    var matchHeight = $.fn.matchHeight = function (options) {
        var opts = _parseOptions(options);

        // handle remove
        if (opts.remove) {
            var that = this;

            // remove fixed height from all selected elements
            this.css(opts.property, '');

            // remove selected elements from all groups
            $.each(matchHeight._groups, function (key, group) {
                group.elements = group.elements.not(that);
            });

            // TODO: cleanup empty groups

            return this;
        }

        if (this.length <= 1 && !opts.target) {
            return this;
        }

        // keep track of this group so we can re-apply later on load and resize events
        matchHeight._groups.push({
            elements: this,
            options: opts
        });

        // match each element's height to the tallest element in the selection
        matchHeight._apply(this, opts);

        return this;
    };

    /*
    *  plugin global options
    */

    matchHeight.version = '0.7.2';
    matchHeight._groups = [];
    matchHeight._throttle = 80;
    matchHeight._maintainScroll = false;
    matchHeight._beforeUpdate = null;
    matchHeight._afterUpdate = null;
    matchHeight._rows = _rows;
    matchHeight._parse = _parse;
    matchHeight._parseOptions = _parseOptions;

    /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */

    matchHeight._apply = function (elements, options) {
        var opts = _parseOptions(options),
            $elements = $(elements),
            rows = [$elements];

        // take note of scroll position
        var scrollTop = $(window).scrollTop(),
            htmlHeight = $('html').outerHeight(true);

        // get hidden parents
        var $hiddenParents = $elements.parents().filter(':hidden');

        // cache the original inline style
        $hiddenParents.each(function () {
            var $that = $(this);
            $that.data('style-cache', $that.attr('style'));
        });

        // temporarily must force hidden parents visible
        $hiddenParents.css('display', 'block');

        // get rows if using byRow, otherwise assume one row
        if (opts.byRow && !opts.target) {

            // must first force an arbitrary equal height so floating elements break evenly
            $elements.each(function () {
                var $that = $(this),
                    display = $that.css('display');

                // temporarily force a usable display value
                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                    display = 'block';
                }

                // cache the original inline style
                $that.data('style-cache', $that.attr('style'));

                $that.css({
                    'display': display,
                    'padding-top': '0',
                    'padding-bottom': '0',
                    'margin-top': '0',
                    'margin-bottom': '0',
                    'border-top-width': '0',
                    'border-bottom-width': '0',
                    'height': '100px',
                    'overflow': 'hidden'
                });
            });

            // get the array of rows (based on element top position)
            rows = _rows($elements);

            // revert original inline styles
            $elements.each(function () {
                var $that = $(this);
                $that.attr('style', $that.data('style-cache') || '');
            });
        }

        $.each(rows, function (key, row) {
            var $row = $(row),
                targetHeight = 0;

            if (!opts.target) {
                // skip apply to rows with only one item
                if (opts.byRow && $row.length <= 1) {
                    $row.css(opts.property, '');
                    return;
                }

                // iterate the row and find the max height
                $row.each(function () {
                    var $that = $(this),
                        style = $that.attr('style'),
                        display = $that.css('display');

                    // temporarily force a usable display value
                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') {
                        display = 'block';
                    }

                    // ensure we get the correct actual height (and not a previously set height value)
                    var css = { 'display': display };
                    css[opts.property] = '';
                    $that.css(css);

                    // find the max height (including padding, but not margin)
                    if ($that.outerHeight(false) > targetHeight) {
                        targetHeight = $that.outerHeight(false);
                    }

                    // revert styles
                    if (style) {
                        $that.attr('style', style);
                    } else {
                        $that.css('display', '');
                    }
                });
            } else {
                // if target set, use the height of the target element
                targetHeight = opts.target.outerHeight(false);
            }

            // iterate the row and apply the height to all elements
            $row.each(function () {
                var $that = $(this),
                    verticalPadding = 0;

                // don't apply to a target
                if (opts.target && $that.is(opts.target)) {
                    return;
                }

                // handle padding and border correctly (required when not using border-box)
                if ($that.css('box-sizing') !== 'border-box') {
                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
                }

                // set the height (accounting for padding and border)
                $that.css(opts.property, targetHeight - verticalPadding + 'px');
            });
        });

        // revert hidden parents
        $hiddenParents.each(function () {
            var $that = $(this);
            $that.attr('style', $that.data('style-cache') || null);
        });

        // restore scroll position if enabled
        if (matchHeight._maintainScroll) {
            $(window).scrollTop(scrollTop / htmlHeight * $('html').outerHeight(true));
        }

        return this;
    };

    /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */

    matchHeight._applyDataApi = function () {
        var groups = {};

        // generate groups by their groupId set by elements using data-match-height
        $('[data-match-height], [data-mh]').each(function () {
            var $this = $(this),
                groupId = $this.attr('data-mh') || $this.attr('data-match-height');

            if (groupId in groups) {
                groups[groupId] = groups[groupId].add($this);
            } else {
                groups[groupId] = $this;
            }
        });

        // apply matchHeight to each group
        $.each(groups, function () {
            this.matchHeight(true);
        });
    };

    /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */

    var _update = function _update(event) {
        if (matchHeight._beforeUpdate) {
            matchHeight._beforeUpdate(event, matchHeight._groups);
        }

        $.each(matchHeight._groups, function () {
            matchHeight._apply(this.elements, this.options);
        });

        if (matchHeight._afterUpdate) {
            matchHeight._afterUpdate(event, matchHeight._groups);
        }
    };

    matchHeight._update = function (throttle, event) {
        // prevent update if fired from a resize event
        // where the viewport width hasn't actually changed
        // fixes an event looping bug in IE8
        if (event && event.type === 'resize') {
            var windowWidth = $(window).width();
            if (windowWidth === _previousResizeWidth) {
                return;
            }
            _previousResizeWidth = windowWidth;
        }

        // throttle updates
        if (!throttle) {
            _update(event);
        } else if (_updateTimeout === -1) {
            _updateTimeout = setTimeout(function () {
                _update(event);
                _updateTimeout = -1;
            }, matchHeight._throttle);
        }
    };

    /*
    *  bind events
    */

    // apply on DOM ready event
    $(matchHeight._applyDataApi);

    // use on or bind where supported
    var on = $.fn.on ? 'on' : 'bind';

    // update heights on load and resize events
    $(window)[on]('load', function (event) {
        matchHeight._update(false, event);
    });

    // throttled update heights on resize events
    $(window)[on]('resize orientationchange', function (event) {
        matchHeight._update(true, event);
    });
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * jQuery Scrollify
 * Version 1.0.19
 *
 * Requires:
 * - jQuery 1.7 or higher
 *
 * https://github.com/lukehaas/Scrollify
 *
 * Copyright 2016, Luke Haas
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.



if touchScroll is false - update index

 */
(function (global, factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['jquery'], function ($) {
      return factory($, global, global.document);
    });
  } else if ((typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object' && module.exports) {
    // Node/CommonJS
    module.exports = factory(require('jquery'), global, global.document);
  } else {
    // Browser globals
    factory(jQuery, global, global.document);
  }
})(typeof window !== 'undefined' ? window : this, function ($, window, document, undefined) {
  "use strict";

  var heights = [],
      names = [],
      elements = [],
      overflow = [],
      beingDestroyed = false,
      index = 0,
      currentIndex = 0,
      interstitialIndex = 1,
      hasLocation = false,
      timeoutId,
      timeoutId2,
      $window = $(window),
      portHeight,
      top = 0,
      // $window.scrollTop(),
  scrollable = false,
      locked = false,
      scrolled = false,
      manualScroll,
      swipeScroll,
      util,
      disabled = false,
      scrollSamples = [],
      scrollDelta = 0,
      scrollTime = new Date().getTime(),
      firstLoad = true,
      initialised = false,
      destination = 0,
      wheelEvent = 'onwheel' in document ? 'wheel' : document.onmousewheel !== undefined ? 'mousewheel' : 'DOMMouseScroll',
      settings = {
    //section should be an identifier that is the same for each section
    section: ".section",
    sectionName: "section-name",
    interstitialSection: "",
    easing: "easeOutExpo",
    scrollSpeed: 1100,
    offset: 0,
    scrollbars: true,
    target: "html,body",
    disableSnapAfter: null,
    standardScrollElements: false,
    setHeights: true,
    overflowScroll: true,
    updateHash: true,
    touchScroll: true,
    before: function before() {},
    after: function after() {},
    afterResize: function afterResize() {},
    afterRender: function afterRender() {}
  };

  function getportHeight() {
    return $window.height() + settings.offset;
  }
  function animateScroll(index, instant, callbacks, toTop) {
    var forceSnap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    if (currentIndex === index) {
      callbacks = false;
    }
    if (disabled === true) {
      return true;
    }
    if (names[index]) {
      scrollable = false;
      if (firstLoad === true) {
        settings.afterRender();
        firstLoad = false;
      }
      if (callbacks) {
        if (typeof settings.before == 'function' && settings.before(index, elements) === false) {
          return true;
        }
      }
      interstitialIndex = 1;
      destination = heights[index];
      if (firstLoad === false && currentIndex > index && toTop === false) {
        //We're going backwards
        if (overflow[index]) {
          portHeight = getportHeight();

          interstitialIndex = parseInt(elements[index].outerHeight() / portHeight);

          destination = parseInt(heights[index]) + (elements[index].outerHeight() - portHeight);
        }
      }

      var indexDelta = index - currentIndex,
          disableSnapAfter = settings.disableSnapAfter;

      if (indexDelta > 0) {
        // Moving down
        disableSnapAfter++;
      }

      if (settings.updateHash && settings.sectionName && !(firstLoad === true && index === 0) && !(null !== disableSnapAfter && index > disableSnapAfter)) {
        if (history.pushState) {
          try {
            history.replaceState(null, null, names[index]);
          } catch (e) {
            if (window.console) {
              console.warn("Scrollify warning: Page must be hosted to manipulate the hash value.");
            }
          }
        } else {
          window.location.hash = names[index];
        }
      }

      currentIndex = index;

      /**
       * The hackery from Adam Taylor.
       * After a certain index, disable the actual scroll snap of the plugin,
       * but retain the ability to update the hashes and trigger callbacks.
       * @author Adam Taylor <adamtaylor@core-marketing.co.uk>
       * @see https://github.com/IAmAdamTaylor/
       */
      if (!forceSnap && null !== disableSnapAfter && index > disableSnapAfter) {

        // Make sure callbacks are called
        locked = false;
        if (callbacks) {
          settings.after(index, elements);
        }
      } else if (instant) {
        $(settings.target).stop().scrollTop(destination);
        if (callbacks) {
          settings.after(index, elements);
        }
      } else {
        locked = true;
        if ($().velocity) {
          $(settings.target).stop().velocity('scroll', {
            duration: settings.scrollSpeed,
            easing: settings.easing,
            offset: destination,
            mobileHA: false
          });
        } else {
          $(settings.target).stop().animate({
            scrollTop: destination
          }, settings.scrollSpeed, settings.easing);
        }

        if (window.location.hash.length && settings.sectionName && window.console) {
          try {
            if ($(window.location.hash).length) {
              console.warn("Scrollify warning: ID matches hash value - this will cause the page to anchor.");
            }
          } catch (e) {}
        }
        $(settings.target).promise().done(function () {
          locked = false;
          firstLoad = false;
          if (callbacks) {
            settings.after(index, elements);
          }
        });
      }
    }
  }

  function isAccelerating(samples) {
    function average(num) {
      var sum = 0;

      var lastElements = samples.slice(Math.max(samples.length - num, 1));

      for (var i = 0; i < lastElements.length; i++) {
        sum += lastElements[i];
      }

      return Math.ceil(sum / num);
    }

    var avEnd = average(10);
    var avMiddle = average(70);

    if (avEnd >= avMiddle) {
      return true;
    } else {
      return false;
    }
  }
  var scrollify = function scrollify(options) {
    initialised = true;
    $.easing['easeOutExpo'] = function (x, t, b, c, d) {
      return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    };

    manualScroll = {
      handleMousedown: function handleMousedown() {
        if (disabled === true) {
          return true;
        }
        scrollable = false;
        scrolled = false;
      },
      handleMouseup: function handleMouseup() {
        if (disabled === true) {
          return true;
        }
        scrollable = true;
        if (scrolled) {
          //instant,callbacks
          manualScroll.calculateNearest(false, true);
        }
      },
      handleScroll: function handleScroll() {
        if (disabled === true) {
          return true;
        }
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(function () {
          scrolled = true;
          if (scrollable === false) {
            return false;
          }
          scrollable = false;
          //instant,callbacks
          manualScroll.calculateNearest(false, true);
        }, 200);
      },
      calculateNearest: function calculateNearest(instant, callbacks) {
        // top = $window.scrollTop();
        top = $(settings.target).scrollTop();
        var i = 1,
            max = heights.length,
            closest = 0,
            prev = Math.abs(heights[0] - top),
            diff;
        for (; i < max; i++) {
          diff = Math.abs(heights[i] - top);

          if (diff < prev) {
            prev = diff;
            closest = i;
          }
        }
        if (atBottom() && closest > index || atTop()) {
          index = closest;
          //index, instant, callbacks, toTop
          animateScroll(closest, instant, callbacks, false);
        }
      },
      wheelHandler: function wheelHandler(e) {
        if (disabled === true) {
          return true;
        } else if (settings.standardScrollElements) {
          if ($(e.target).is(settings.standardScrollElements) || $(e.target).closest(settings.standardScrollElements).length) {
            return true;
          }
        }
        if (!overflow[index]) {
          e.preventDefault();
        }
        var currentScrollTime = new Date().getTime();

        e = e || window.event;
        var value = e.originalEvent.wheelDelta || -e.originalEvent.deltaY || -e.originalEvent.detail;
        var delta = Math.max(-1, Math.min(1, value));

        //delta = delta || -e.originalEvent.detail / 3 || e.originalEvent.wheelDelta / 120;

        if (delta != scrollDelta) {
          scrollSamples = [];
          scrollDelta = delta;
        }

        if (scrollSamples.length > 149) {
          scrollSamples.shift();
        }
        //scrollSamples.push(Math.abs(delta*10));
        scrollSamples.push(Math.abs(value));

        if (currentScrollTime - scrollTime > 200) {
          scrollSamples = [];
        }
        scrollTime = currentScrollTime;

        if (locked) {
          return false;
        }
        if (delta < 0) {
          if (index < heights.length - 1) {
            if (atBottom()) {
              if (isAccelerating(scrollSamples)) {
                // Moving down

                index++;
                e.preventDefault();

                if (!(null !== settings.disableSnapAfter && index > settings.disableSnapAfter + 1)) {
                  locked = true;
                }

                //index, instant, callbacks, toTop
                animateScroll(index, false, true, false);
              } else {
                return false;
              }
            }
          }
        } else if (delta > 0) {
          if (index > 0) {
            if (atTop()) {
              if (isAccelerating(scrollSamples)) {
                // Moving up

                index--;
                e.preventDefault();

                if (!(null !== settings.disableSnapAfter && index > settings.disableSnapAfter)) {
                  locked = true;
                }

                //index, instant, callbacks, toTop
                animateScroll(index, false, true, false);
              } else {
                return false;
              }
            }
          }
        }
      },
      keyHandler: function keyHandler(e) {
        if (disabled === true || document.activeElement.readOnly === false) {
          return true;
        } else if (settings.standardScrollElements) {
          if ($(e.target).is(settings.standardScrollElements) || $(e.target).closest(settings.standardScrollElements).length) {
            return true;
          }
        }
        if (locked === true) {
          return false;
        }
        if (e.keyCode == 38 || e.keyCode == 33) {
          if (index > 0) {
            if (atTop()) {
              e.preventDefault();
              index--;
              //index, instant, callbacks, toTop
              animateScroll(index, false, true, false);
            }
          }
        } else if (e.keyCode == 40 || e.keyCode == 34) {
          if (index < heights.length - 1) {
            if (atBottom()) {
              e.preventDefault();
              index++;
              //index, instant, callbacks, toTop
              animateScroll(index, false, true, false);
            }
          }
        }
      },
      init: function init() {
        if (settings.scrollbars) {
          // $window.on('mousedown', manualScroll.handleMousedown);
          // $window.on('mouseup', manualScroll.handleMouseup);
          // $window.on('scroll', manualScroll.handleScroll);

          $(settings.target).on('mousedown', manualScroll.handleMousedown);
          $(settings.target).on('mouseup', manualScroll.handleMouseup);
          $(settings.target).on('scroll', manualScroll.handleScroll);
        } else {
          $("body").css({ "overflow": "hidden" });
        }
        $window.on(wheelEvent, manualScroll.wheelHandler);
        //$(document).bind(wheelEvent,manualScroll.wheelHandler);
        $window.on('keydown', manualScroll.keyHandler);
      }
    };

    swipeScroll = {
      touches: {
        "touchstart": { "y": -1, "x": -1 },
        "touchmove": { "y": -1, "x": -1 },
        "touchend": false,
        "direction": "undetermined"
      },
      options: {
        "distance": 30,
        "timeGap": 800,
        "timeStamp": new Date().getTime()
      },
      touchHandler: function touchHandler(event) {
        if (disabled === true) {
          return true;
        } else if (settings.standardScrollElements) {
          if ($(event.target).is(settings.standardScrollElements) || $(event.target).closest(settings.standardScrollElements).length) {
            return true;
          }
        }
        var touch;
        if (typeof event !== 'undefined') {
          if (typeof event.touches !== 'undefined') {
            touch = event.touches[0];
            switch (event.type) {
              case 'touchstart':
                swipeScroll.touches.touchstart.y = touch.pageY;
                swipeScroll.touches.touchmove.y = -1;

                swipeScroll.touches.touchstart.x = touch.pageX;
                swipeScroll.touches.touchmove.x = -1;

                swipeScroll.options.timeStamp = new Date().getTime();
                swipeScroll.touches.touchend = false;
              case 'touchmove':
                swipeScroll.touches.touchmove.y = touch.pageY;
                swipeScroll.touches.touchmove.x = touch.pageX;
                if (swipeScroll.touches.touchstart.y !== swipeScroll.touches.touchmove.y && Math.abs(swipeScroll.touches.touchstart.y - swipeScroll.touches.touchmove.y) > Math.abs(swipeScroll.touches.touchstart.x - swipeScroll.touches.touchmove.x)) {
                  //if(!overflow[index]) {
                  event.preventDefault();
                  //}
                  swipeScroll.touches.direction = "y";
                  if (swipeScroll.options.timeStamp + swipeScroll.options.timeGap < new Date().getTime() && swipeScroll.touches.touchend == false) {

                    swipeScroll.touches.touchend = true;
                    if (swipeScroll.touches.touchstart.y > -1) {

                      if (Math.abs(swipeScroll.touches.touchmove.y - swipeScroll.touches.touchstart.y) > swipeScroll.options.distance) {
                        if (swipeScroll.touches.touchstart.y < swipeScroll.touches.touchmove.y) {

                          swipeScroll.up();
                        } else {
                          swipeScroll.down();
                        }
                      }
                    }
                  }
                }
                break;
              case 'touchend':
                if (swipeScroll.touches[event.type] === false) {
                  swipeScroll.touches[event.type] = true;
                  if (swipeScroll.touches.touchstart.y > -1 && swipeScroll.touches.touchmove.y > -1 && swipeScroll.touches.direction === "y") {

                    if (Math.abs(swipeScroll.touches.touchmove.y - swipeScroll.touches.touchstart.y) > swipeScroll.options.distance) {
                      if (swipeScroll.touches.touchstart.y < swipeScroll.touches.touchmove.y) {
                        swipeScroll.up();
                      } else {
                        swipeScroll.down();
                      }
                    }
                    swipeScroll.touches.touchstart.y = -1;
                    swipeScroll.touches.touchstart.x = -1;
                    swipeScroll.touches.direction = "undetermined";
                  }
                }
              default:
                break;
            }
          }
        }
      },
      down: function down() {

        if (index < heights.length) {

          if (atBottom() && index < heights.length - 1) {

            index++;
            //index, instant, callbacks, toTop
            animateScroll(index, false, true, false);
          } else {
            portHeight = getportHeight();
            if (Math.floor(elements[index].height() / portHeight) > interstitialIndex) {

              interstitialScroll(parseInt(heights[index]) + portHeight * interstitialIndex);
              interstitialIndex += 1;
            } else {
              interstitialScroll(parseInt(heights[index]) + (elements[index].outerHeight() - portHeight));
            }
          }
        }
      },
      up: function up() {
        if (index >= 0) {
          if (atTop() && index > 0) {

            index--;
            //index, instant, callbacks, toTop
            animateScroll(index, false, true, false);
          } else {

            if (interstitialIndex > 2) {
              portHeight = getportHeight();

              interstitialIndex -= 1;
              interstitialScroll(parseInt(heights[index]) + portHeight * interstitialIndex);
            } else {

              interstitialIndex = 1;
              interstitialScroll(parseInt(heights[index]));
            }
          }
        }
      },
      init: function init() {
        if (document.addEventListener && settings.touchScroll) {
          var eventListenerOptions = {
            passive: false
          };
          document.addEventListener('touchstart', swipeScroll.touchHandler, eventListenerOptions);
          document.addEventListener('touchmove', swipeScroll.touchHandler, eventListenerOptions);
          document.addEventListener('touchend', swipeScroll.touchHandler, eventListenerOptions);
        }
      }
    };

    util = {
      refresh: function refresh(withCallback, scroll) {
        clearTimeout(timeoutId2);
        timeoutId2 = setTimeout(function () {
          //retain position
          sizePanels(true);
          //scroll, firstLoad
          calculatePositions(scroll, false);
          if (withCallback) {
            settings.afterResize();
          }
        }, 400);
      },
      handleUpdate: function handleUpdate() {
        //callbacks, scroll
        //changed from false,true to false,false
        util.refresh(false, false);
      },
      handleResize: function handleResize() {
        if (beingDestroyed) {
          beingDestroyed = false;
        } else {
          //callbacks, scroll
          util.refresh(true, false);
        }
      },
      handleOrientation: function handleOrientation() {
        //callbacks, scroll
        util.refresh(true, true);
      }
    };
    settings = $.extend(settings, options);

    //retain position
    sizePanels(false);

    calculatePositions(false, true);

    if (true === hasLocation) {
      //index, instant, callbacks, toTop, forceSnap
      animateScroll(index, false, true, true, true);
    } else {
      setTimeout(function () {
        //instant,callbacks
        manualScroll.calculateNearest(true, false);
      }, 200);
    }
    if (heights.length) {
      manualScroll.init();
      swipeScroll.init();

      $window.on("resize.scrollify", debounce(util.handleResize, 155));
      if (document.addEventListener) {
        window.addEventListener("orientationchange", util.handleOrientation, false);
      }
    }
    function interstitialScroll(pos) {
      if ($().velocity) {
        $(settings.target).stop().velocity('scroll', {
          duration: settings.scrollSpeed,
          easing: settings.easing,
          offset: pos,
          mobileHA: false
        });
      } else {
        $(settings.target).stop().animate({
          scrollTop: pos
        }, settings.scrollSpeed, settings.easing);
      }
    }

    function sizePanels(keepPosition) {
      if (keepPosition) {
        // top = $window.scrollTop();
        top = $(settings.target).scrollTop();
      }

      var selector = settings.section;
      overflow = [];
      if (settings.interstitialSection.length) {
        selector += "," + settings.interstitialSection;
      }
      if (settings.scrollbars === false) {
        settings.overflowScroll = false;
      }
      portHeight = getportHeight();
      $(selector).each(function (i) {
        var $this = $(this);

        if (settings.setHeights) {
          if ($this.is(settings.interstitialSection)) {
            overflow[i] = false;
          } else if (null !== settings.disableSnapAfter && i > settings.disableSnapAfter) {
            overflow[i] = true;
          } else {
            if ($this.css("height", "auto").outerHeight() < portHeight || $this.css("overflow") === "hidden") {
              $this.css({ "height": portHeight });

              overflow[i] = false;
            } else {
              $this.css({ "height": $this.outerHeight() });

              if (settings.overflowScroll) {
                overflow[i] = true;
              } else {
                overflow[i] = false;
              }
            }
          }
        } else {

          if ($this.outerHeight() < portHeight || settings.overflowScroll === false) {
            overflow[i] = false;
          } else {
            overflow[i] = true;
          }
        }
      });
      if (keepPosition) {
        // $window.scrollTop(top);
        $(settings.target).scrollTop(top);
      }
    }
    function calculatePositions(scroll, firstLoad) {
      var selector = settings.section;
      if (settings.interstitialSection.length) {
        selector += "," + settings.interstitialSection;
      }
      heights = [];
      names = [];
      elements = [];
      $(selector).each(function (i) {
        var $this = $(this);
        if (i > 0) {
          heights[i] = parseInt($this.offset().top + $(settings.target).scrollTop()) + settings.offset;
        } else {
          heights[i] = parseInt($this.offset().top + $(settings.target).scrollTop());
        }
        if (settings.sectionName && $this.data(settings.sectionName)) {
          names[i] = "#" + $this.data(settings.sectionName).toString().replace(/ /g, "-");
        } else {
          if ($this.is(settings.interstitialSection) === false) {
            names[i] = "#" + (i + 1);
          } else {
            names[i] = "#";
            if (i === $(selector).length - 1 && i > 1) {
              heights[i] = heights[i - 1] + (parseInt($($(selector)[i - 1]).outerHeight()) - parseInt($(window).height())) + parseInt($this.outerHeight());
            }
          }
        }
        elements[i] = $this;
        try {
          if ($(names[i]).length && window.console) {
            console.warn("Scrollify warning: Section names can't match IDs - this will cause the browser to anchor.");
          }
        } catch (e) {}

        if (window.location.hash === names[i]) {
          index = i;
          hasLocation = true;
        }
      });

      if (true === scroll) {
        //index, instant, callbacks, toTop
        animateScroll(index, false, false, false);
      }
    }

    function atTop() {
      if (!overflow[index]) {
        return true;
      }
      // top = $window.scrollTop();
      top = $(settings.target).scrollTop();
      if (top > parseInt(heights[index])) {
        return false;
      } else {
        return true;
      }
    }
    function atBottom() {
      if (!overflow[index]) {
        return true;
      }
      // top = $window.scrollTop();
      top = $(settings.target).scrollTop();
      portHeight = getportHeight();

      if (top < parseInt(heights[index]) + (elements[index].outerHeight() - portHeight) - 28) {

        return false;
      } else {
        return true;
      }
    }
  };

  function move(panel, instant) {
    var forceSnap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var z = names.length;
    for (; z >= 0; z--) {
      if (typeof panel === 'string') {
        if (names[z] === panel) {
          index = z;
          //index, instant, callbacks, toTop, forceSnap
          animateScroll(z, instant, true, true, forceSnap);
        }
      } else {
        if (z === panel) {
          index = z;
          //index, instant, callbacks, toTop, forceSnap
          animateScroll(z, instant, true, true, forceSnap);
        }
      }
    }
  }
  scrollify.move = function (panel, forceSnap) {
    if (panel === undefined) {
      return false;
    }
    if (panel.originalEvent) {
      panel = $(this).attr("href");
    }
    move(panel, false, forceSnap);
  };
  scrollify.instantMove = function (panel) {
    if (panel === undefined) {
      return false;
    }
    move(panel, true);
  };
  scrollify.next = function () {
    if (index < names.length) {
      index += 1;
      //index, instant, callbacks, toTop
      animateScroll(index, false, true, true);
    }
  };
  scrollify.previous = function () {
    if (index > 0) {
      index -= 1;
      //index, instant, callbacks, toTop
      animateScroll(index, false, true, true);
    }
  };
  scrollify.instantNext = function () {
    if (index < names.length) {
      index += 1;
      //index, instant, callbacks, toTop
      animateScroll(index, true, true, true);
    }
  };
  scrollify.instantPrevious = function () {
    if (index > 0) {
      index -= 1;
      //index, instant, callbacks, toTop
      animateScroll(index, true, true, true);
    }
  };
  scrollify.destroy = function () {
    if (!initialised) {
      return false;
    }
    beingDestroyed = true;
    $window.off("resize.scrollify");
    if (settings.scrollbars) {
      $window.off('mousedown', manualScroll.handleMousedown);
      $window.off('mouseup', manualScroll.handleMouseup);
      $window.off('scroll', manualScroll.handleScroll);
    }
    $window.off(wheelEvent, manualScroll.wheelHandler);
    $window.off('keydown', manualScroll.keyHandler);

    if (document.addEventListener && settings.touchScroll) {
      document.removeEventListener('touchstart', swipeScroll.touchHandler, false);
      document.removeEventListener('touchmove', swipeScroll.touchHandler, false);
      document.removeEventListener('touchend', swipeScroll.touchHandler, false);
    }
    if (settings.setHeights) {
      $(settings.section).each(function () {
        $(this).css("height", "");
      });
    }
    heights = [];
    names = [];
    elements = [];
    overflow = [];
    firstLoad = true;
  };
  scrollify.update = function () {
    if (!initialised) {
      return false;
    }
    util.handleUpdate();
  };
  scrollify.current = function () {
    return elements[index];
  };
  scrollify.currentIndex = function () {
    return index;
  };
  scrollify.disable = function () {
    disabled = true;
  };
  scrollify.enable = function () {
    disabled = false;
    if (initialised) {
      //instant,callbacks
      manualScroll.calculateNearest(false, false);
    }
  };
  scrollify.isDisabled = function () {
    return disabled;
  };
  scrollify.setOptions = function (updatedOptions) {
    if (!initialised) {
      return false;
    }
    if ((typeof updatedOptions === 'undefined' ? 'undefined' : _typeof(updatedOptions)) === "object") {
      settings = $.extend(settings, updatedOptions);
      util.handleUpdate();
    } else if (window.console) {
      console.warn("Scrollify warning: setOptions expects an object.");
    }
  };
  scrollify.elements = function () {
    return elements;
  };
  $.scrollify = scrollify;
  return scrollify;
});
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */
/* global window, document, define, jQuery, setInterval, clearInterval */
;(function (factory) {
    'use strict';

    if (typeof define === 'function' && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== 'undefined') {
        module.exports = factory(require('jquery'));
    } else {
        factory(jQuery);
    }
})(function ($) {
    'use strict';

    var Slick = window.Slick || {};

    Slick = function () {

        var instanceUid = 0;

        function Slick(element, settings) {

            var _ = this,
                dataSettings;

            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };

            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };

            $.extend(_, _.initials);

            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;

            dataSettings = $(element).data('slick') || {};

            _.options = $.extend({}, _.defaults, settings, dataSettings);

            _.currentSlide = _.options.initialSlide;

            _.originalSettings = _.options;

            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }

            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);

            _.instanceUid = instanceUid++;

            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

            _.registerBreakpoints();
            _.init(true);
        }

        return Slick;
    }();

    Slick.prototype.activateADA = function () {
        var _ = this;

        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };

    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

        var _ = this;

        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) {
            return false;
        }

        _.unload();

        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) {
                $(markup).appendTo(_.$slideTrack);
            } else if (addBefore) {
                $(markup).insertBefore(_.$slides.eq(index));
            } else {
                $(markup).insertAfter(_.$slides.eq(index));
            }
        } else {
            if (addBefore === true) {
                $(markup).prependTo(_.$slideTrack);
            } else {
                $(markup).appendTo(_.$slideTrack);
            }
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index);
        });

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.animateHeight = function () {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };

    Slick.prototype.animateSlide = function (targetLeft, callback) {

        var animProps = {},
            _ = this;

        _.animateHeight();

        if (_.options.rtl === true && _.options.vertical === false) {
            targetLeft = -targetLeft;
        }
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) {
                _.$slideTrack.animate({
                    left: targetLeft
                }, _.options.speed, _.options.easing, callback);
            } else {
                _.$slideTrack.animate({
                    top: targetLeft
                }, _.options.speed, _.options.easing, callback);
            }
        } else {

            if (_.cssTransitions === false) {
                if (_.options.rtl === true) {
                    _.currentLeft = -_.currentLeft;
                }
                $({
                    animStart: _.currentLeft
                }).animate({
                    animStart: targetLeft
                }, {
                    duration: _.options.speed,
                    easing: _.options.easing,
                    step: function step(now) {
                        now = Math.ceil(now);
                        if (_.options.vertical === false) {
                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                            _.$slideTrack.css(animProps);
                        } else {
                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
                            _.$slideTrack.css(animProps);
                        }
                    },
                    complete: function complete() {
                        if (callback) {
                            callback.call();
                        }
                    }
                });
            } else {

                _.applyTransition();
                targetLeft = Math.ceil(targetLeft);

                if (_.options.vertical === false) {
                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
                } else {
                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
                }
                _.$slideTrack.css(animProps);

                if (callback) {
                    setTimeout(function () {

                        _.disableTransition();

                        callback.call();
                    }, _.options.speed);
                }
            }
        }
    };

    Slick.prototype.getNavTarget = function () {

        var _ = this,
            asNavFor = _.options.asNavFor;

        if (asNavFor && asNavFor !== null) {
            asNavFor = $(asNavFor).not(_.$slider);
        }

        return asNavFor;
    };

    Slick.prototype.asNavFor = function (index) {

        var _ = this,
            asNavFor = _.getNavTarget();

        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
            asNavFor.each(function () {
                var target = $(this).slick('getSlick');
                if (!target.unslicked) {
                    target.slideHandler(index, true);
                }
            });
        }
    };

    Slick.prototype.applyTransition = function (slide) {

        var _ = this,
            transition = {};

        if (_.options.fade === false) {
            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        } else {
            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        }

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.autoPlay = function () {

        var _ = this;

        _.autoPlayClear();

        if (_.slideCount > _.options.slidesToShow) {
            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
        }
    };

    Slick.prototype.autoPlayClear = function () {

        var _ = this;

        if (_.autoPlayTimer) {
            clearInterval(_.autoPlayTimer);
        }
    };

    Slick.prototype.autoPlayIterator = function () {

        var _ = this,
            slideTo = _.currentSlide + _.options.slidesToScroll;

        if (!_.paused && !_.interrupted && !_.focussed) {

            if (_.options.infinite === false) {

                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
                    _.direction = 0;
                } else if (_.direction === 0) {

                    slideTo = _.currentSlide - _.options.slidesToScroll;

                    if (_.currentSlide - 1 === 0) {
                        _.direction = 1;
                    }
                }
            }

            _.slideHandler(slideTo);
        }
    };

    Slick.prototype.buildArrows = function () {

        var _ = this;

        if (_.options.arrows === true) {

            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

            if (_.slideCount > _.options.slidesToShow) {

                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

                if (_.htmlExpr.test(_.options.prevArrow)) {
                    _.$prevArrow.prependTo(_.options.appendArrows);
                }

                if (_.htmlExpr.test(_.options.nextArrow)) {
                    _.$nextArrow.appendTo(_.options.appendArrows);
                }

                if (_.options.infinite !== true) {
                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                }
            } else {

                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                    'aria-disabled': 'true',
                    'tabindex': '-1'
                });
            }
        }
    };

    Slick.prototype.buildDots = function () {

        var _ = this,
            i,
            dot;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$slider.addClass('slick-dotted');

            dot = $('<ul />').addClass(_.options.dotsClass);

            for (i = 0; i <= _.getDotCount(); i += 1) {
                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            }

            _.$dots = dot.appendTo(_.options.appendDots);

            _.$dots.find('li').first().addClass('slick-active');
        }
    };

    Slick.prototype.buildOut = function () {

        var _ = this;

        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

        _.slideCount = _.$slides.length;

        _.$slides.each(function (index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });

        _.$slider.addClass('slick-slider');

        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);

        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
            _.options.slidesToScroll = 1;
        }

        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

        _.setupInfinite();

        _.buildArrows();

        _.buildDots();

        _.updateDots();

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        if (_.options.draggable === true) {
            _.$list.addClass('draggable');
        }
    };

    Slick.prototype.buildRows = function () {

        var _ = this,
            a,
            b,
            c,
            newSlides,
            numOfSlides,
            originalSlides,
            slidesPerSection;

        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();

        if (_.options.rows > 0) {

            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

            for (a = 0; a < numOfSlides; a++) {
                var slide = document.createElement('div');
                for (b = 0; b < _.options.rows; b++) {
                    var row = document.createElement('div');
                    for (c = 0; c < _.options.slidesPerRow; c++) {
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) {
                            row.appendChild(originalSlides.get(target));
                        }
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }

            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };

    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

        var _ = this,
            breakpoint,
            targetBreakpoint,
            respondToWidth,
            triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();

        if (_.respondTo === 'window') {
            respondToWidth = windowWidth;
        } else if (_.respondTo === 'slider') {
            respondToWidth = sliderWidth;
        } else if (_.respondTo === 'min') {
            respondToWidth = Math.min(windowWidth, sliderWidth);
        }

        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

            targetBreakpoint = null;

            for (breakpoint in _.breakpoints) {
                if (_.breakpoints.hasOwnProperty(breakpoint)) {
                    if (_.originalSettings.mobileFirst === false) {
                        if (respondToWidth < _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    } else {
                        if (respondToWidth > _.breakpoints[breakpoint]) {
                            targetBreakpoint = _.breakpoints[breakpoint];
                        }
                    }
                }
            }

            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                            _.unslick(targetBreakpoint);
                        } else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) {
                                _.currentSlide = _.options.initialSlide;
                            }
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
                        _.unslick(targetBreakpoint);
                    } else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) {
                            _.currentSlide = _.options.initialSlide;
                        }
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else {
                if (_.activeBreakpoint !== null) {
                    _.activeBreakpoint = null;
                    _.options = _.originalSettings;
                    if (initial === true) {
                        _.currentSlide = _.options.initialSlide;
                    }
                    _.refresh(initial);
                    triggerBreakpoint = targetBreakpoint;
                }
            }

            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) {
                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
            }
        }
    };

    Slick.prototype.changeSlide = function (event, dontAnimate) {

        var _ = this,
            $target = $(event.currentTarget),
            indexOffset,
            slideOffset,
            unevenOffset;

        // If target is a link, prevent default action.
        if ($target.is('a')) {
            event.preventDefault();
        }

        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) {
            $target = $target.closest('li');
        }

        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

        switch (event.data.message) {

            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                }
                break;

            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) {
                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                }
                break;

            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;

            default:
                return;
        }
    };

    Slick.prototype.checkNavigable = function (index) {

        var _ = this,
            navigables,
            prevNavigable;

        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) {
            index = navigables[navigables.length - 1];
        } else {
            for (var n in navigables) {
                if (index < navigables[n]) {
                    index = prevNavigable;
                    break;
                }
                prevNavigable = navigables[n];
            }
        }

        return index;
    };

    Slick.prototype.cleanUpEvents = function () {

        var _ = this;

        if (_.options.dots && _.$dots !== null) {

            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));

            if (_.options.accessibility === true) {
                _.$dots.off('keydown.slick', _.keyHandler);
            }
        }

        _.$slider.off('focus.slick blur.slick');

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }

        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

        _.$list.off('click.slick', _.clickHandler);

        $(document).off(_.visibilityChange, _.visibility);

        _.cleanUpSlideEvents();

        if (_.options.accessibility === true) {
            _.$list.off('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        }

        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };

    Slick.prototype.cleanUpSlideEvents = function () {

        var _ = this;

        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };

    Slick.prototype.cleanUpRows = function () {

        var _ = this,
            originalSlides;

        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };

    Slick.prototype.clickHandler = function (event) {

        var _ = this;

        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };

    Slick.prototype.destroy = function (refresh) {

        var _ = this;

        _.autoPlayClear();

        _.touchObject = {};

        _.cleanUpEvents();

        $('.slick-cloned', _.$slider).detach();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.$prevArrow.length) {

            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.prevArrow)) {
                _.$prevArrow.remove();
            }
        }

        if (_.$nextArrow && _.$nextArrow.length) {

            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

            if (_.htmlExpr.test(_.options.nextArrow)) {
                _.$nextArrow.remove();
            }
        }

        if (_.$slides) {

            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
                $(this).attr('style', $(this).data('originalStyling'));
            });

            _.$slideTrack.children(this.options.slide).detach();

            _.$slideTrack.detach();

            _.$list.detach();

            _.$slider.append(_.$slides);
        }

        _.cleanUpRows();

        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');

        _.unslicked = true;

        if (!refresh) {
            _.$slider.trigger('destroy', [_]);
        }
    };

    Slick.prototype.disableTransition = function (slide) {

        var _ = this,
            transition = {};

        transition[_.transitionType] = '';

        if (_.options.fade === false) {
            _.$slideTrack.css(transition);
        } else {
            _.$slides.eq(slide).css(transition);
        }
    };

    Slick.prototype.fadeSlide = function (slideIndex, callback) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });

            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });

            if (callback) {
                setTimeout(function () {

                    _.disableTransition(slideIndex);

                    callback.call();
                }, _.options.speed);
            }
        }
    };

    Slick.prototype.fadeSlideOut = function (slideIndex) {

        var _ = this;

        if (_.cssTransitions === false) {

            _.$slides.eq(slideIndex).animate({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            }, _.options.speed, _.options.easing);
        } else {

            _.applyTransition(slideIndex);

            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };

    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

        var _ = this;

        if (filter !== null) {

            _.$slidesCache = _.$slides;

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.focusHandler = function () {

        var _ = this;

        // If any child element receives focus within the slider we need to pause the autoplay
        _.$slider.off('focus.slick blur.slick').on('focus.slick', '*', function (event) {
            var $sf = $(this);

            setTimeout(function () {
                if (_.options.pauseOnFocus) {
                    if ($sf.is(':focus')) {
                        _.focussed = true;
                        _.autoPlay();
                    }
                }
            }, 0);
        }).on('blur.slick', '*', function (event) {
            var $sf = $(this);

            // When a blur occurs on any elements within the slider we become unfocused
            if (_.options.pauseOnFocus) {
                _.focussed = false;
                _.autoPlay();
            }
        });
    };

    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

        var _ = this;
        return _.currentSlide;
    };

    Slick.prototype.getDotCount = function () {

        var _ = this;

        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;

        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) {
                ++pagerQty;
            } else {
                while (breakPoint < _.slideCount) {
                    ++pagerQty;
                    breakPoint = counter + _.options.slidesToScroll;
                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
                }
            }
        } else if (_.options.centerMode === true) {
            pagerQty = _.slideCount;
        } else if (!_.options.asNavFor) {
            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        } else {
            while (breakPoint < _.slideCount) {
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        }

        return pagerQty - 1;
    };

    Slick.prototype.getLeft = function (slideIndex) {

        var _ = this,
            targetLeft,
            verticalHeight,
            verticalOffset = 0,
            targetSlide,
            coef;

        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);

        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;

                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) {
                        coef = -1.5;
                    } else if (_.options.slidesToShow === 1) {
                        coef = -2;
                    }
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else {
            if (slideIndex + _.options.slidesToShow > _.slideCount) {
                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
            }
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }

        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
            _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        } else if (_.options.centerMode === true && _.options.infinite === true) {
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        } else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }

        if (_.options.vertical === false) {
            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        } else {
            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        }

        if (_.options.variableWidth === true) {

            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            } else {
                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            }

            if (_.options.rtl === true) {
                if (targetSlide[0]) {
                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                } else {
                    targetLeft = 0;
                }
            } else {
                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            }

            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                } else {
                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                }

                if (_.options.rtl === true) {
                    if (targetSlide[0]) {
                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    } else {
                        targetLeft = 0;
                    }
                } else {
                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                }

                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }

        return targetLeft;
    };

    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

        var _ = this;

        return _.options[option];
    };

    Slick.prototype.getNavigableIndexes = function () {

        var _ = this,
            breakPoint = 0,
            counter = 0,
            indexes = [],
            max;

        if (_.options.infinite === false) {
            max = _.slideCount;
        } else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }

        while (breakPoint < max) {
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }

        return indexes;
    };

    Slick.prototype.getSlick = function () {

        return this;
    };

    Slick.prototype.getSlideCount = function () {

        var _ = this,
            slidesTraversed,
            swipedSlide,
            centerOffset;

        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });

            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

            return slidesTraversed;
        } else {
            return _.options.slidesToScroll;
        }
    };

    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };

    Slick.prototype.init = function (creation) {

        var _ = this;

        if (!$(_.$slider).hasClass('slick-initialized')) {

            $(_.$slider).addClass('slick-initialized');

            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }

        if (creation) {
            _.$slider.trigger('init', [_]);
        }

        if (_.options.accessibility === true) {
            _.initADA();
        }

        if (_.options.autoplay) {

            _.paused = false;
            _.autoPlay();
        }
    };

    Slick.prototype.initADA = function () {
        var _ = this,
            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
            return val >= 0 && val < _.slideCount;
        });

        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });

        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);

                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });

                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) {
                        $(this).attr({
                            'aria-describedby': ariaButtonControl
                        });
                    }
                }
            });

            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
                var mappedSlideIndex = tabControlIndexes[i];

                $(this).attr({
                    'role': 'presentation'
                });

                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }

        for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
            if (_.options.focusOnChange) {
                _.$slides.eq(i).attr({ 'tabindex': '0' });
            } else {
                _.$slides.eq(i).removeAttr('tabindex');
            }
        }

        _.activateADA();
    };

    Slick.prototype.initArrowEvents = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };

    Slick.prototype.initDotEvents = function () {

        var _ = this;

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);

            if (_.options.accessibility === true) {
                _.$dots.on('keydown.slick', _.keyHandler);
            }
        }

        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initSlideEvents = function () {

        var _ = this;

        if (_.options.pauseOnHover) {

            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };

    Slick.prototype.initializeEvents = function () {

        var _ = this;

        _.initArrowEvents();

        _.initDotEvents();
        _.initSlideEvents();

        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);

        _.$list.on('click.slick', _.clickHandler);

        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

        if (_.options.accessibility === true) {
            _.$list.on('keydown.slick', _.keyHandler);
        }

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };

    Slick.prototype.initUI = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.show();
            _.$nextArrow.show();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.show();
        }
    };

    Slick.prototype.keyHandler = function (event) {

        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'next' : 'previous'
                    }
                });
            } else if (event.keyCode === 39 && _.options.accessibility === true) {
                _.changeSlide({
                    data: {
                        message: _.options.rtl === true ? 'previous' : 'next'
                    }
                });
            }
        }
    };

    Slick.prototype.lazyLoad = function () {

        var _ = this,
            loadRange,
            cloneRange,
            rangeStart,
            rangeEnd;

        function loadImages(imagesScope) {

            $('img[data-lazy]', imagesScope).each(function () {

                var image = $(this),
                    imageSource = $(this).attr('data-lazy'),
                    imageSrcSet = $(this).attr('data-srcset'),
                    imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
                    imageToLoad = document.createElement('img');

                imageToLoad.onload = function () {

                    image.animate({ opacity: 0 }, 100, function () {

                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);

                            if (imageSizes) {
                                image.attr('sizes', imageSizes);
                            }
                        }

                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                    });
                };

                imageToLoad.onerror = function () {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
                };

                imageToLoad.src = imageSource;
            });
        }

        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }

        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1,
                nextSlide = rangeEnd,
                $slides = _.$slider.find('.slick-slide');

            for (var i = 0; i < _.options.slidesToScroll; i++) {
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }

        loadImages(loadRange);

        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };

    Slick.prototype.loadSlider = function () {

        var _ = this;

        _.setPosition();

        _.$slideTrack.css({
            opacity: 1
        });

        _.$slider.removeClass('slick-loading');

        _.initUI();

        if (_.options.lazyLoad === 'progressive') {
            _.progressiveLazyLoad();
        }
    };

    Slick.prototype.next = Slick.prototype.slickNext = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };

    Slick.prototype.orientationChange = function () {

        var _ = this;

        _.checkResponsive();
        _.setPosition();
    };

    Slick.prototype.pause = Slick.prototype.slickPause = function () {

        var _ = this;

        _.autoPlayClear();
        _.paused = true;
    };

    Slick.prototype.play = Slick.prototype.slickPlay = function () {

        var _ = this;

        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };

    Slick.prototype.postSlide = function (index) {

        var _ = this;

        if (!_.unslicked) {

            _.$slider.trigger('afterChange', [_, index]);

            _.animating = false;

            if (_.slideCount > _.options.slidesToShow) {
                _.setPosition();
            }

            _.swipeLeft = null;

            if (_.options.autoplay) {
                _.autoPlay();
            }

            if (_.options.accessibility === true) {
                _.initADA();

                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };

    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

        var _ = this;

        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };

    Slick.prototype.preventDefault = function (event) {

        event.preventDefault();
    };

    Slick.prototype.progressiveLazyLoad = function (tryCount) {

        tryCount = tryCount || 1;

        var _ = this,
            $imgsToLoad = $('img[data-lazy]', _.$slider),
            image,
            imageSource,
            imageSrcSet,
            imageSizes,
            imageToLoad;

        if ($imgsToLoad.length) {

            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');

            imageToLoad.onload = function () {

                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);

                    if (imageSizes) {
                        image.attr('sizes', imageSizes);
                    }
                }

                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');

                if (_.options.adaptiveHeight === true) {
                    _.setPosition();
                }

                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
                _.progressiveLazyLoad();
            };

            imageToLoad.onerror = function () {

                if (tryCount < 3) {

                    /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */
                    setTimeout(function () {
                        _.progressiveLazyLoad(tryCount + 1);
                    }, 500);
                } else {

                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

                    _.progressiveLazyLoad();
                }
            };

            imageToLoad.src = imageSource;
        } else {

            _.$slider.trigger('allImagesLoaded', [_]);
        }
    };

    Slick.prototype.refresh = function (initializing) {

        var _ = this,
            currentSlide,
            lastVisibleIndex;

        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
            _.currentSlide = lastVisibleIndex;
        }

        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        currentSlide = _.currentSlide;

        _.destroy(true);

        $.extend(_, _.initials, { currentSlide: currentSlide });

        _.init();

        if (!initializing) {

            _.changeSlide({
                data: {
                    message: 'index',
                    index: currentSlide
                }
            }, false);
        }
    };

    Slick.prototype.registerBreakpoints = function () {

        var _ = this,
            breakpoint,
            currentBreakpoint,
            l,
            responsiveSettings = _.options.responsive || null;

        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

            _.respondTo = _.options.respondTo || 'window';

            for (breakpoint in responsiveSettings) {

                l = _.breakpoints.length - 1;

                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while (l >= 0) {
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
                            _.breakpoints.splice(l, 1);
                        }
                        l--;
                    }

                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }

            _.breakpoints.sort(function (a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };

    Slick.prototype.reinit = function () {

        var _ = this;

        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

        _.slideCount = _.$slides.length;

        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        }

        if (_.slideCount <= _.options.slidesToShow) {
            _.currentSlide = 0;
        }

        _.registerBreakpoints();

        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();

        _.checkResponsive(false, true);

        if (_.options.focusOnSelect === true) {
            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        }

        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

        _.setPosition();
        _.focusHandler();

        _.paused = !_.options.autoplay;
        _.autoPlay();

        _.$slider.trigger('reInit', [_]);
    };

    Slick.prototype.resize = function () {

        var _ = this;

        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function () {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) {
                    _.setPosition();
                }
            }, 50);
        }
    };

    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

        var _ = this;

        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else {
            index = removeBefore === true ? --index : index;
        }

        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
            return false;
        }

        _.unload();

        if (removeAll === true) {
            _.$slideTrack.children().remove();
        } else {
            _.$slideTrack.children(this.options.slide).eq(index).remove();
        }

        _.$slides = _.$slideTrack.children(this.options.slide);

        _.$slideTrack.children(this.options.slide).detach();

        _.$slideTrack.append(_.$slides);

        _.$slidesCache = _.$slides;

        _.reinit();
    };

    Slick.prototype.setCSS = function (position) {

        var _ = this,
            positionProps = {},
            x,
            y;

        if (_.options.rtl === true) {
            position = -position;
        }
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

        positionProps[_.positionProp] = position;

        if (_.transformsEnabled === false) {
            _.$slideTrack.css(positionProps);
        } else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };

    Slick.prototype.setDimensions = function () {

        var _ = this;

        if (_.options.vertical === false) {
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: '0px ' + _.options.centerPadding
                });
            }
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) {
                _.$list.css({
                    padding: _.options.centerPadding + ' 0px'
                });
            }
        }

        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();

        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) {
            _.$slideTrack.width(5000 * _.slideCount);
        } else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }

        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };

    Slick.prototype.setFade = function () {

        var _ = this,
            targetLeft;

        _.$slides.each(function (index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) {
                $(element).css({
                    position: 'relative',
                    right: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            } else {
                $(element).css({
                    position: 'relative',
                    left: targetLeft,
                    top: 0,
                    zIndex: _.options.zIndex - 2,
                    opacity: 0
                });
            }
        });

        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };

    Slick.prototype.setHeight = function () {

        var _ = this;

        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };

    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */

        var _ = this,
            l,
            item,
            option,
            value,
            refresh = false,
            type;

        if ($.type(arguments[0]) === 'object') {

            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {

            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];

            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

                type = 'responsive';
            } else if (typeof arguments[1] !== 'undefined') {

                type = 'single';
            }
        }

        if (type === 'single') {

            _.options[option] = value;
        } else if (type === 'multiple') {

            $.each(option, function (opt, val) {

                _.options[opt] = val;
            });
        } else if (type === 'responsive') {

            for (item in value) {

                if ($.type(_.options.responsive) !== 'array') {

                    _.options.responsive = [value[item]];
                } else {

                    l = _.options.responsive.length - 1;

                    // loop through the responsive object and splice out duplicates.
                    while (l >= 0) {

                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

                            _.options.responsive.splice(l, 1);
                        }

                        l--;
                    }

                    _.options.responsive.push(value[item]);
                }
            }
        }

        if (refresh) {

            _.unload();
            _.reinit();
        }
    };

    Slick.prototype.setPosition = function () {

        var _ = this;

        _.setDimensions();

        _.setHeight();

        if (_.options.fade === false) {
            _.setCSS(_.getLeft(_.currentSlide));
        } else {
            _.setFade();
        }

        _.$slider.trigger('setPosition', [_]);
    };

    Slick.prototype.setProps = function () {

        var _ = this,
            bodyStyle = document.body.style;

        _.positionProp = _.options.vertical === true ? 'top' : 'left';

        if (_.positionProp === 'top') {
            _.$slider.addClass('slick-vertical');
        } else {
            _.$slider.removeClass('slick-vertical');
        }

        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) {
                _.cssTransitions = true;
            }
        }

        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) {
                    _.options.zIndex = 3;
                }
            } else {
                _.options.zIndex = _.defaults.zIndex;
            }
        }

        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };

    Slick.prototype.setSlideClasses = function (index) {

        var _ = this,
            centerOffset,
            allSlides,
            indexOffset,
            remainder;

        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

        _.$slides.eq(index).addClass('slick-current');

        if (_.options.centerMode === true) {

            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

            centerOffset = Math.floor(_.options.slidesToShow / 2);

            if (_.options.infinite === true) {

                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
                    _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }

                if (index === 0) {

                    allSlides.eq(allSlides.length - _.slideCount).addClass('slick-center');
                } else if (index === _.slideCount - 1) {

                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
                }
            }

            _.$slides.eq(index).addClass('slick-center');
        } else {

            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            } else if (allSlides.length <= _.options.slidesToShow) {

                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            } else {

                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                } else {

                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
                }
            }
        }

        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
            _.lazyLoad();
        }
    };

    Slick.prototype.setupInfinite = function () {

        var _ = this,
            i,
            slideIndex,
            infiniteCount;

        if (_.options.fade === true) {
            _.options.centerMode = false;
        }

        if (_.options.infinite === true && _.options.fade === false) {

            slideIndex = null;

            if (_.slideCount > _.options.slidesToShow) {

                if (_.options.centerMode === true) {
                    infiniteCount = _.options.slidesToShow + 1;
                } else {
                    infiniteCount = _.options.slidesToShow;
                }

                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
                    $(this).attr('id', '');
                });
            }
        }
    };

    Slick.prototype.interrupt = function (toggle) {

        var _ = this;

        if (!toggle) {
            _.autoPlay();
        }
        _.interrupted = toggle;
    };

    Slick.prototype.selectHandler = function (event) {

        var _ = this;

        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

        var index = parseInt(targetElement.attr('data-slick-index'));

        if (!index) index = 0;

        if (_.slideCount <= _.options.slidesToShow) {

            _.slideHandler(index, false, true);
            return;
        }

        _.slideHandler(index);
    };

    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

        var targetSlide,
            animSlide,
            oldSlide,
            slideLeft,
            targetLeft = null,
            _ = this,
            navTarget;

        sync = sync || false;

        if (_.animating === true && _.options.waitForAnimate === true) {
            return;
        }

        if (_.options.fade === true && _.currentSlide === index) {
            return;
        }

        if (sync === false) {
            _.asNavFor(index);
        }

        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);

        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
                    _.animateSlide(slideLeft, function () {
                        _.postSlide(targetSlide);
                    });
                } else {
                    _.postSlide(targetSlide);
                }
            }
            return;
        }

        if (_.options.autoplay) {
            clearInterval(_.autoPlayTimer);
        }

        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            } else {
                animSlide = _.slideCount + targetSlide;
            }
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                animSlide = 0;
            } else {
                animSlide = targetSlide - _.slideCount;
            }
        } else {
            animSlide = targetSlide;
        }

        _.animating = true;

        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;

        _.setSlideClasses(_.currentSlide);

        if (_.options.asNavFor) {

            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');

            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
                navTarget.setSlideClasses(_.currentSlide);
            }
        }

        _.updateDots();
        _.updateArrows();

        if (_.options.fade === true) {
            if (dontAnimate !== true) {

                _.fadeSlideOut(oldSlide);

                _.fadeSlide(animSlide, function () {
                    _.postSlide(animSlide);
                });
            } else {
                _.postSlide(animSlide);
            }
            _.animateHeight();
            return;
        }

        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
            _.animateSlide(targetLeft, function () {
                _.postSlide(animSlide);
            });
        } else {
            _.postSlide(animSlide);
        }
    };

    Slick.prototype.startLoad = function () {

        var _ = this;

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }

        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

            _.$dots.hide();
        }

        _.$slider.addClass('slick-loading');
    };

    Slick.prototype.swipeDirection = function () {

        var xDist,
            yDist,
            r,
            swipeAngle,
            _ = this;

        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);

        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) {
            swipeAngle = 360 - Math.abs(swipeAngle);
        }

        if (swipeAngle <= 45 && swipeAngle >= 0) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle <= 360 && swipeAngle >= 315) {
            return _.options.rtl === false ? 'left' : 'right';
        }
        if (swipeAngle >= 135 && swipeAngle <= 225) {
            return _.options.rtl === false ? 'right' : 'left';
        }
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) {
                return 'down';
            } else {
                return 'up';
            }
        }

        return 'vertical';
    };

    Slick.prototype.swipeEnd = function (event) {

        var _ = this,
            slideCount,
            direction;

        _.dragging = false;
        _.swiping = false;

        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }

        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

        if (_.touchObject.curX === undefined) {
            return false;
        }

        if (_.touchObject.edgeHit === true) {
            _.$slider.trigger('edge', [_, _.swipeDirection()]);
        }

        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

            direction = _.swipeDirection();

            switch (direction) {

                case 'left':
                case 'down':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

                    _.currentDirection = 0;

                    break;

                case 'right':
                case 'up':

                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

                    _.currentDirection = 1;

                    break;

                default:

            }

            if (direction != 'vertical') {

                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [_, direction]);
            }
        } else {

            if (_.touchObject.startX !== _.touchObject.curX) {

                _.slideHandler(_.currentSlide);
                _.touchObject = {};
            }
        }
    };

    Slick.prototype.swipeHandler = function (event) {

        var _ = this;

        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
            return;
        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
            return;
        }

        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

        if (_.options.verticalSwiping === true) {
            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        }

        switch (event.data.action) {

            case 'start':
                _.swipeStart(event);
                break;

            case 'move':
                _.swipeMove(event);
                break;

            case 'end':
                _.swipeEnd(event);
                break;

        }
    };

    Slick.prototype.swipeMove = function (event) {

        var _ = this,
            edgeWasHit = false,
            curLeft,
            swipeDirection,
            swipeLength,
            positionOffset,
            touches,
            verticalSwipeLength;

        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
            return false;
        }

        curLeft = _.getLeft(_.currentSlide);

        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }

        if (_.options.verticalSwiping === true) {
            _.touchObject.swipeLength = verticalSwipeLength;
        }

        swipeDirection = _.swipeDirection();

        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }

        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) {
            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        }

        swipeLength = _.touchObject.swipeLength;

        _.touchObject.edgeHit = false;

        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }

        if (_.options.vertical === false) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        } else {
            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        }
        if (_.options.verticalSwiping === true) {
            _.swipeLeft = curLeft + swipeLength * positionOffset;
        }

        if (_.options.fade === true || _.options.touchMove === false) {
            return false;
        }

        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }

        _.setCSS(_.swipeLeft);
    };

    Slick.prototype.swipeStart = function (event) {

        var _ = this,
            touches;

        _.interrupted = true;

        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }

        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
            touches = event.originalEvent.touches[0];
        }

        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

        _.dragging = true;
    };

    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

        var _ = this;

        if (_.$slidesCache !== null) {

            _.unload();

            _.$slideTrack.children(this.options.slide).detach();

            _.$slidesCache.appendTo(_.$slideTrack);

            _.reinit();
        }
    };

    Slick.prototype.unload = function () {

        var _ = this;

        $('.slick-cloned', _.$slider).remove();

        if (_.$dots) {
            _.$dots.remove();
        }

        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
            _.$prevArrow.remove();
        }

        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
            _.$nextArrow.remove();
        }

        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };

    Slick.prototype.unslick = function (fromBreakpoint) {

        var _ = this;
        _.$slider.trigger('unslick', [_, fromBreakpoint]);
        _.destroy();
    };

    Slick.prototype.updateArrows = function () {

        var _ = this,
            centerOffset;

        centerOffset = Math.floor(_.options.slidesToShow / 2);

        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

            if (_.currentSlide === 0) {

                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };

    Slick.prototype.updateDots = function () {

        var _ = this;

        if (_.$dots !== null) {

            _.$dots.find('li').removeClass('slick-active').end();

            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };

    Slick.prototype.visibility = function () {

        var _ = this;

        if (_.options.autoplay) {

            if (document[_.hidden]) {

                _.interrupted = true;
            } else {

                _.interrupted = false;
            }
        }
    };

    $.fn.slick = function () {
        var _ = this,
            opt = arguments[0],
            args = Array.prototype.slice.call(arguments, 1),
            l = _.length,
            i,
            ret;
        for (i = 0; i < l; i++) {
            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});
function getPageUrl() {
	var url = window.location.href;

	// Strip any anchors
	url = -1 === url.indexOf('#') ? url : url.substr(0, url.indexOf('#'));

	return url;
}

/**
 * Get the query parameters, or a named one, from any passed URL.
 * @param  {String} url   A full URL with query parameters.
 * @param  {String} name  Optional, The name of the query parameter.
 *                        Leave blank to return all parsed parameters.
 * @return {Array|String} If name is passed:
 *                           The query parameter if it is set,
 *                           		Array for multiple values with same key,
 *                           		String for single values
 *                           false otherwise
 *                        Else
 *                       		 The full parsed GET array if any params are set,
 *                       		 or a blank array if there are none.
 */
function getQueryArg(url) {
	var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	if (-1 === url.indexOf('?')) {
		return name ? false : [];
	}

	// Strip any anchors
	url = -1 === url.indexOf('#') ? url : url.substr(0, url.indexOf('#'));

	var GET = function () {
		var qd = {};
		/**
   * Split the url on the query string start '?', 
   * then split 2nd part i.e. the query string into each parameter.
   * For each parameter, parse the values and fill qd with found keys & values.
   * 
   * @see https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript/21152762#21152762
   * - Slightly modified to work for any URL string
   */
		url.split('?')[1].split('&').forEach(function (item) {
			var _split = item.split('=');
			var k = _split[0] && decodeURIComponent(_split[0]);
			var v = _split[1] && decodeURIComponent(_split[1]);

			// If k denotes a nested value strip the array index
			// E.g. foo[0], foo[1] => foo
			var matches = k.match(/(.*)\[(\d)+\]$/);
			if (matches && '' !== matches[0]) {
				k = matches[1];
			}

			(qd[k] = qd[k] || []).push(v);
		});
		return qd;
	}();

	if (name) {
		if (GET[name] && GET[name].length > 1) {
			return GET[name];
		} else if (GET[name]) {
			return GET[name][0];
		} else {
			return false;
		}
	} else {
		return GET;
	}
}

/**
 * Add a query arg to the src attribute on an oEmbed item.
 * This function does not support adding multiple args.
 * @param  {string} key   The query arg name.
 * @param  {string} value The query arg value.
 * @param  {string} url   Optional, The base URL. Defaults to document.location.
 * @return string         The URL with the query arg added.
 */
function addQueryArg(key, value) {
	var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	if (!url) {
		url = document.location.href;
	}

	// Check for an existing query string
	var queryStringPos = url.indexOf('?');

	if (queryStringPos == -1) {
		return url + ('?' + key + '=' + value);
	}

	var queryString = url.substr(queryStringPos + 1).split('&');
	var queryStringKeys = queryString.map(function (arg) {
		return arg.split('=')[0];
	});

	// Check for an existing key value
	var keyPosition = queryStringKeys.indexOf(key);

	if (keyPosition == -1) {
		return url + ('&' + key + '=' + value);
	}

	// At this point we know there is an existing query string containing the key.
	// Replace the existing key's value with the new value.
	queryString[keyPosition] = key + '=' + value;

	// Rebuild the full URL
	return url.substr(0, queryStringPos + 1) + queryString.join('&');
}

/**
 * A multiple args version of the above function.
 * @param {Object} args An object with { key: value } pairs of args.
 * @param {String} url  The URL with the query args added.
 */
function addQueryArgs(args) {
	var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	if (!url) {
		url = document.location.href;
	}

	// Iterate args properties
	var keys = Object.keys(args),
	    len = keys.length;
	for (var i = 0; i < len; i++) {
		url = addQueryArg(keys[i], args[keys[i]], url);
	}

	return url;
}
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Smoothly scroll to anchor links with specific duration.

(function ($, window, document, undefined) {

	var SmoothScroll = function () {
		/**
   * Setup the class and properites.
   * @param  {Number} duration  The duration of the scroll, in ms.
   * @param  {Number} offset 		The amount, in pixels, to offset the final position.
   *                           	Negative values will stop before the y specified,
   *                         	  Positive values will stop after the y specified.
   */
		function SmoothScroll() {
			var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 400;
			var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

			_classCallCheck(this, SmoothScroll);

			var _ = this;

			_.$root = $('.js-main-scroll-container');
			_.duration = duration;
			_.offset = offset;
		}

		/**
   * Scroll to a specific element.
   * @param  {jQuery|String} $element The element to scroll to. 
   *                                  Accepts a jQuery element or a selector string.
   * @return {self}
   */


		_createClass(SmoothScroll, [{
			key: 'toElement',
			value: function toElement($element) {
				var _ = this;

				$element = $($element);

				if ($element.length) {
					_._scroll($element.offset().top + _.$root.scrollTop());
				}

				return _;
			}

			/**
    * Scroll to a position on the screen.
    * @param  {Number} y The y coordinate to scroll to.
    * @return {self}
    */

		}, {
			key: 'toPosition',
			value: function toPosition(y) {
				var _ = this;

				_._scroll(y);

				return _;
			}

			/**
    * Animate the current scroll position to a y coordinate.
    * The final scroll position will be offset by the class offset property.
    * @param  {Number} y The y coordinate to scroll to.
    * @return {self}
    */

		}, {
			key: '_scroll',
			value: function _scroll(y) {
				var _ = this;

				_.$root.animate({
					scrollTop: y + _.offset
				}, {
					duration: _.duration,
					/**
      * A completion function triggered when the scroll finishes.
      * Use `$('html').on('complete.SmoothScroll')` to listen for it.
      * @param {Event} event The event object triggered.
      */
					complete: debounce(function () {
						_.$root.eq(0).trigger('complete.SmoothScroll');
					}, 50)
				});

				return _;
			}

			/**
    * Set a new offset for method calls to this class.
    * The current offset will be stored on the class so that
    * it can be restored later on.
    * @param {Number} offset The amount of pixels to offset the final scroll position.
    *                        Negative values will stop before the top of the element,
    *                        positive values will stop after the top of the element. 
    */

		}, {
			key: 'setTempOffset',
			value: function setTempOffset(offset) {
				var _ = this;

				// Set private property offset to current class property
				// Can be restored later
				_._offset = _.offset;
				// Set class property to passed offset
				_.offset = offset;

				return _;
			}

			/**
    * Restore the offset applied earlier by setTempOffset().
    * @return {self}
    */

		}, {
			key: 'restoreOffset',
			value: function restoreOffset() {
				var _ = this;

				// Check for existence of temp property
				if (null !== _._offset && undefined !== _._offset) {
					// Set class property to temp property
					_.offset = _._offset;
					// Unset temp property
					_._offset = null;
				}

				return _;
			}
		}]);

		return SmoothScroll;
	}();

	// Expose API
	window.SmoothScroll = new SmoothScroll(400, -60);
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Stop viewport scroll when fixed element containers are open.
 *
 * Because of the potential for modals within modals, disable() is designed 
 * to be called multiple times. 
 * Scroll will only be reenabled once enable() has been called the 
 * same number of times as disable() was originally called.
 */

(function ($, window, document, undefined) {

	var ViewportScroll = function () {
		/**
   * Setup the class and properties.
   */
		function ViewportScroll() {
			_classCallCheck(this, ViewportScroll);

			var _ = this;

			_._disabledCount = 0;
			_._scrollTop = $(window).scrollTop();

			_._bindEvents();
		}

		_createClass(ViewportScroll, [{
			key: '_bindEvents',
			value: function _bindEvents() {
				var _ = this;

				// Restore scroll position when window refreshes
				window.onbeforeunload = function () {
					if (_.isDisabled()) {
						$('body').css({
							'position': '',
							'top': '',
							'overflow-y': ''
						});
						window.scrollTo(0, _._scrollTop);
					}
				};

				return _;
			}

			/**
    * Disable scroll on the viewport.
    * @return {self}
    */

		}, {
			key: 'disable',
			value: function disable() {
				var _ = this;

				_._disabledCount++;

				if (1 === _._disabledCount) {
					_._scrollTop = $(window).scrollTop();

					$('body').css({
						position: 'fixed',
						top: -(_._scrollTop - parseInt($('html').css('marginTop'))) + 'px',
						overflowY: 'scroll'
					});
				}

				return _._disabledCount;
			}

			/**
    * Enable scroll on the viewport.
    * @return {self}
    */

		}, {
			key: 'enable',
			value: function enable() {
				var _ = this;

				_._disabledCount--;
				// Constrain to min of 0
				_._disabledCount = Math.max(0, _._disabledCount);

				if (0 === _._disabledCount) {
					$('body').css({
						'position': '',
						'top': '',
						'overflow-y': ''
					});
					$(window).scrollTop(_._scrollTop);
				}

				return _;
			}

			/**
    * Check if viewport scrolling is disabled.
    * @return {Boolean}
    */

		}, {
			key: 'isDisabled',
			value: function isDisabled() {
				var _ = this;

				return _._disabledCount > 0;
			}

			/**
    * Get the number of times required to call enable()
    * before viewport scroll is reenabled.
    * @return {Number}
    */

		}, {
			key: 'getDisabledCount',
			value: function getDisabledCount() {
				var _ = this;

				return _._disabledCount;
			}
		}]);

		return ViewportScroll;
	}();

	// Expose API
	window.ViewportScroll = new ViewportScroll();
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Contact Form Validation

(function ($, window, document, undefined) {

  /**
    * Represents a single form field.
    * Handles showing errors and validating common field types.
    */
  var FormField = function () {
    function FormField($field) {
      _classCallCheck(this, FormField);

      var _ = this;

      _.$field = $field;
      _.hasError = false;

      $field.on('removeError', function () {
        return _.removeError();
      });
    }

    /**
     * Alias val() function from jQuery.
     */


    _createClass(FormField, [{
      key: 'val',
      value: function val() {
        var _ = this;

        return _.$field.val();
      }

      /**
       * Show an error attached to the field.
       * @param {String} message The error message to show.
       * @return {self}
       */

    }, {
      key: 'addError',
      value: function addError(message) {
        var _ = this,
            fieldMessage = new FormFieldMessage(_.$field);

        _.$field.addClass('has-error');

        fieldMessage.setStatus('error').setMessage(message);
        _.hasError = true;

        return _;
      }

      /**
       * Remove an error being shown on the field.
       * @return {self}
       */

    }, {
      key: 'removeError',
      value: function removeError() {
        var _ = this,
            fieldMessage = new FormFieldMessage(_.$field);

        _.$field.removeClass('has-error');

        fieldMessage.hide();
        _.hasError = false;

        return _;
      }

      /**
       * Check if the field is required and if it is,
       * whether it has a non empty value.
       * @return {Boolean}
       */

    }, {
      key: 'isRequiredAndValid',
      value: function isRequiredAndValid() {
        var _ = this;

        if ('checkbox' == _.$field.attr('type')) {
          return _.$field.is('[required]') && _.$field.prop('checked');
        } else {
          return _.$field.is('[required]') && _.$field.val() !== "";
        }
      }

      /**
       * Check if the field has a minimum length
       * determined by it's HTML attributes.
       * @return {Boolean}
       */

    }, {
      key: 'hasMinLength',
      value: function hasMinLength() {
        var _ = this,

        // Force string type
        value = _.$field.val() + "",
            minLength = _.$field.attr('minlength');

        return value.length >= minLength;
      }

      /**
       * Check if the field is a standard email format.
       * @return {Boolean}
       */

    }, {
      key: 'isEmail',
      value: function isEmail() {
        var _ = this,
            emailRegex = /^[A-Z0-9._%+-]+@(?:[A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

        return emailRegex.test(_.$field.val());
      }

      /**
       * Check if the field is a standard phone number format.
       * Because some people may wish to write values such as
       *   "Day 0121... Night 07999..."
       * this check only requires at least 9 numbers in the field.
       * @return {Boolean}
       */

    }, {
      key: 'isPhone',
      value: function isPhone() {
        var _ = this,
            replaceRegex = /[^0-9+]/g,
            phoneValue = _.$field.val().replace(replaceRegex, '');

        return phoneValue.length >= 9;
      }

      /**
       * Test if the field value matches a specific regex pattern.
       * @param  {String|RegExp} regex A string pattern or a regex object. 
       * @return {Boolean}
       */

    }, {
      key: 'matchesPattern',
      value: function matchesPattern(regex) {
        var _ = this;

        return regex.test(_.$field.val());
      }
    }]);

    return FormField;
  }();

  /**
   * A single message element attached to a form field.
   * The message can represent information or an error in the value entered.
   */
  var FormFieldMessage = function () {
    function FormFieldMessage($field) {
      _classCallCheck(this, FormFieldMessage);

      var _ = this;

      _.$field = $field;

      _._elementSelector = '.js-input-message';
      _._animationSpeed = 250;

      _.$message = _.getElement();
    }

    /**
     * Get a jQuery element representing a 
     * message attached to the form field.
     * If there is not a message element, one will be created.
     * @return {jQuery} The message element, found or creeated.
     */


    _createClass(FormFieldMessage, [{
      key: 'getElement',
      value: function getElement() {
        var _ = this,
            $message = _.$field.siblings(_._elementSelector);

        if (!$message.length) {
          $message = $('<p class="input-message js-input-message" data-field="#' + _.$field.attr('id') + '" style="display:none;"></p>');
          // Insert into DOM
          _.$field.after($message);
        }

        return $message;
      }

      /**
       * Set the status of the message.
       * @param {String} status The status to set. Can be anything, however 
       *                        some choices are: notice, info, error.
       * @return {self}
       */

    }, {
      key: 'setStatus',
      value: function setStatus(status) {
        var _ = this;

        _.$message.addClass('input-message--' + status + ' js-input-message--' + status);

        return _;
      }

      /**
       * Set the message text.
       * @param {String} message The text to set.
       * @return {self}
       */

    }, {
      key: 'setMessage',
      value: function setMessage(message) {
        var _ = this;

        _.$message.html(message);

        if (!_.$message.is(':visible')) {
          _.show();
        } else {
          _.blink();
        }

        return _;
      }

      /**
       * Show the message.
       * @return {self} 
       */

    }, {
      key: 'show',
      value: function show() {
        var _ = this;

        _.$message.slideDown(_._animationSpeed);

        return _;
      }

      /**
       * Make the message blink once to attract attention.
       * @return {self} 
       */

    }, {
      key: 'blink',
      value: function blink() {
        var _ = this;

        _.$message.hide().fadeIn(_._animationSpeed);

        return _;
      }

      /**
       * Hide the message.
       * @return {self} 
       */

    }, {
      key: 'hide',
      value: function hide() {
        var _ = this;

        _.$message.slideUp(_._animationSpeed);

        return _;
      }
    }]);

    return FormFieldMessage;
  }();

  var ContactFormController = function () {
    function ContactFormController($form) {
      _classCallCheck(this, ContactFormController);

      var _ = this;

      _.$form = $form;

      _.fields = {
        fullname: new FormField(_.$form.find('#fullname')),
        email: new FormField(_.$form.find('#email')),
        phone: new FormField(_.$form.find('#phone')),
        subject: new FormField(_.$form.find('#subject')),
        enquiry: new FormField(_.$form.find('#enquiry'))
      };
    }

    /**
     * Validate the form.
     * @return {Boolean} True if the form validated with no errors,
     *                   false otherwise.
     */


    _createClass(ContactFormController, [{
      key: 'validate',
      value: function validate() {
        var _ = this,
            fields = _.fields,
            validated = true;

        if (!fields.fullname.isRequiredAndValid()) {
          fields.fullname.addError('Enter your name');
          validated = false;
        } else if (!fields.fullname.hasMinLength()) {
          fields.fullname.addError('Your name should be at least ' + fields.fullname.$field.attr('minlength') + ' characters');
          validated = false;
        }

        if (!fields.email.isRequiredAndValid()) {
          fields.email.addError('Enter your email');
          validated = false;
        } else if (!fields.email.isEmail()) {
          fields.email.addError('Enter a valid email');
          validated = false;
        }

        if (!fields.phone.isRequiredAndValid()) {
          fields.phone.addError('Enter your phone number');
          validated = false;
        } else if (!fields.phone.isPhone()) {
          fields.phone.addError('Enter a valid phone number');
          validated = false;
        }

        if (!fields.subject.isRequiredAndValid()) {
          fields.subject.addError('Enter a subject');
          validated = false;
        }

        if (!fields.enquiry.isRequiredAndValid()) {
          fields.enquiry.addError('Enter an enquiry');
          validated = false;
        } else if (!fields.enquiry.hasMinLength()) {
          fields.enquiry.addError('Your enquiry should be at least ' + fields.enquiry.$field.attr('minlength') + ' characters');
          validated = false;
        }

        return validated;
      }
    }]);

    return ContactFormController;
  }();

  var NewsletterFormController = function () {
    function NewsletterFormController($form) {
      _classCallCheck(this, NewsletterFormController);

      var _ = this;

      _.$form = $form;

      _.fields = {
        fullname: new FormField(_.$form.find('#fullname')),
        email: new FormField(_.$form.find('#email')),
        // Fake birthday field for errors on fields below
        birthday: new FormField(_.$form.find('#birthday')),
        // Real birthday fields
        birthday_day: new FormField(_.$form.find('#birthday_day')),
        birthday_month: new FormField(_.$form.find('#birthday_month')),
        birthday_year: new FormField(_.$form.find('#birthday_year')),
        gdpr_consent: new FormField(_.$form.find('#gdpr_consent')),
        gdpr_consent_parent: new FormField(_.$form.find('#gdpr_consent_parent'))
      };
    }

    /**
     * Validate the form.
     * @return {Boolean} True if the form validated with no errors,
     *                   false otherwise.
     */


    _createClass(NewsletterFormController, [{
      key: 'validate',
      value: function validate() {
        var _ = this,
            fields = _.fields,
            validated = true;

        if (!fields.fullname.isRequiredAndValid()) {
          fields.fullname.addError('Enter your name');
          validated = false;
        } else if (!fields.fullname.hasMinLength()) {
          fields.fullname.addError('Your name should be at least ' + fields.fullname.$field.attr('minlength') + ' characters');
          validated = false;
        }

        if (!fields.email.isRequiredAndValid()) {
          fields.email.addError('Enter your email');
          validated = false;
        } else if (!fields.email.isEmail()) {
          fields.email.addError('Enter a valid email');
          validated = false;
        }

        // If any of the birthday fields are filled...
        if (fields.birthday_day.val() || fields.birthday_month.val() || fields.birthday_year.val()) {

          var birthdayHasError = false;

          // ...ensure all of them are filled
          if (!fields.birthday_day.val() || !fields.birthday_month.val() || !fields.birthday_year.val()) {
            fields.birthday.addError('Make sure all fields are filled');
            birthdayHasError = true;
          }

          // ...that individual fields are the correct length & format (digits not a-z)
          // N.B. Although we are checking individual fields there is not enough space
          // for each to have their own error message, so apply it to the container
          if (!birthdayHasError && (!fields.birthday_day.matchesPattern(/^\d{1,2}$/) || !fields.birthday_month.matchesPattern(/^\d{1,2}$/) || !fields.birthday_year.matchesPattern(/^\d{4}$/))) {
            fields.birthday.addError('Please check the format - day and month should be 1 or 2 numbers and year should be 4 numbers');
            birthdayHasError = true;
          }

          // ...that fields are not out of range, e.g. day greater than 31, month greater than 12

          // Create a testing date - for invalid dates the returned values will be NaN or not match what was passed
          var dateTest = new Date(fields.birthday_year.val() + '-' + fields.birthday_month.val() + '-' + fields.birthday_day.val());

          if (!birthdayHasError && (fields.birthday_day.val() > 31 || fields.birthday_month.val() > 12 || fields.birthday_day.val() != dateTest.getDate() || fields.birthday_month.val() != dateTest.getMonth() + 1 || isNaN(dateTest.getDate()))) {
            fields.birthday.addError('You&rsquo;ve entered an invalid date. Please check the values and try&nbsp;again.');
            birthdayHasError = true;
          }

          // ...and that it is not in the future
          var today = new Date(),
              today_day = today.getDate(),
              today_month = today.getMonth() + 1,
              today_year = today.getFullYear();

          if (!birthdayHasError && (
          // In future test
          fields.birthday_year.val() > today_year || fields.birthday_year.val() == today_year && fields.birthday_month.val() > today_month || fields.birthday_year.val() == today_year && fields.birthday_month.val() == today_month && fields.birthday_day.val() > today_day)) {
            fields.birthday.addError('You&rsquo;ve entered a date in the future. Please check the values and try&nbsp;again.');
            birthdayHasError = true;
          }

          // Update validation state once at end, rather than in every conditional
          if (birthdayHasError) {
            validated = false;
          }
        }

        if (!fields.gdpr_consent.isRequiredAndValid()) {
          fields.gdpr_consent_parent.addError('You must tick the checkbox above to opt-in to receive our newsletter');
          validated = false;
        }

        return validated;
      }
    }]);

    return NewsletterFormController;
  }();

  // Expose API
  window.FormField = FormField;
  window.FormFieldMessage = FormFieldMessage;
  window.ContactFormController = ContactFormController;
  window.NewsletterFormController = NewsletterFormController;
})(jQuery, window, document);
// Contact Form Handler

(function ($, window, document, undefined) {

  var $contactForm = $('#contact');

  if ($contactForm.length) {
    var _contactFormController = new ContactFormController($contactForm);

    // Stop the browser showing it's default error handling UI, only when the JS has loaded
    $contactForm.attr('novalidate', 'true');

    // Listen for bubbled events from button
    // Submit events fire default HTML5 validation as well
    $contactForm.find('#contact_submit').on('click', function (event) {

      if (!_contactFormController.validate()) {

        // Scroll to and focus first error
        var errorFound = false;
        $.each(_contactFormController.fields, function (index, field) {
          if (field.hasError && !errorFound) {
            // Force offset so that whole form element is showing
            window.SmoothScroll.setTempOffset(-100).toElement(field.$field).restoreOffset();
            field.$field.focus();

            errorFound = true;
          }
        });

        event.preventDefault();
        return false;
      }
    });

    $contactForm.on('submit', function (event) {
      $contactForm.find('#contact_submit').html('Sending&hellip;');
    });
  }

  // Listen for change events and hide field errors
  $contactForm.find('input, textarea, select').on('change', function (event) {
    var $this = $(event.target),
        formField = new FormField($this);

    $this.trigger('removeError');
  });
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Menu drawers controller

(function ($, window, document, undefined) {

	var MenuDrawerController = function () {
		function MenuDrawerController($drawer, $button, $menu) {
			_classCallCheck(this, MenuDrawerController);

			var _ = this;

			_.$drawer = $drawer;
			_.$button = $button;
			_.$menu = $menu;

			_.animationSpeed = 300;
		}

		/**
   * Open a menu drawer.
   * @return {self} 
   */


		_createClass(MenuDrawerController, [{
			key: 'open',
			value: function open() {
				var _ = this;

				_.$menu.slideDown(_.animationSpeed, function () {
					// On complete
					$(document).trigger('menu-drawer-changed-state', [_.$drawer, 'open']);
					_.$menu.attr('aria-hidden', 'false');
				});

				_.$drawer.addClass('is-open');

				return _;
			}

			/**
    * Close a menu drawer.
    * @return {self} 
    */

		}, {
			key: 'close',
			value: function close() {
				var _ = this;

				_.$menu.slideUp(_.animationSpeed, function () {
					$(document).trigger('menu-drawer-changed-state', [_.$drawer, 'close']);

					_.$menu.attr('aria-hidden', 'true');
					_.$drawer.removeClass('is-open');
				});

				return _;
			}

			/**
    * Toggle a menu drawer between open and closed.
    * @return {self} 
    */

		}, {
			key: 'toggle',
			value: function toggle() {
				var _ = this;

				if (_.isOpen()) {
					_.close();
				} else {
					_.open();
				}

				return _;
			}

			/**
    * Check if a menu drawer is open.
    * @return {Boolean} 
    */

		}, {
			key: 'isOpen',
			value: function isOpen() {
				var _ = this;

				return _.$menu.is(':visible');
			}
		}]);

		return MenuDrawerController;
	}();

	window.MenuDrawerController = MenuDrawerController;
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Video Controller

(function ($, window, document, undefined) {

	var VideoController = function () {
		function VideoController($wrapper) {
			_classCallCheck(this, VideoController);

			var _ = this;

			_.$wrapper = $wrapper;

			if (!_.video) {
				_._lazyload();
			}
		}

		/**
   * Load the HTML5 <video> element JIT (Just in Time).
   * @return {self}
   */


		_createClass(VideoController, [{
			key: '_lazyload',
			value: function _lazyload() {
				var _ = this;

				// See if there is already a video in the wrapper
				// Return early if found
				var $video = _.$wrapper.find('video');

				if ($video.length) {
					_.video = $video.get(0);
					return _;
				}

				// else, Create the video element and append to the wrapper
				$video = $('<video autoplay muted playsinline></video>');
				$video.attr('poster', _.$wrapper.css('backgroundImage').replace(/url\(\"([^\"]*)\"\)/, '$1'));

				var $source = $('<source></source>');
				$source.attr('src', _.$wrapper.attr('data-video'));

				$video.append($source);
				$video.css('visibility', 'hidden');

				// Listen for ready to play events to prevent buffer flickering
				$video.on('canplay', function () {
					$video.css('visibility', '');
				});

				_.$wrapper.append($video);
				_.video = $video.get(0);

				return _;
			}

			/**
    * Pause the video.
    * @return {self} 
    */

		}, {
			key: 'pause',
			value: function pause() {
				var _ = this;

				if (_.video) {
					_.video.pause();
				}

				return _;
			}

			/**
    * Check if the video is paused.
    * @return {boolean}
    */

		}, {
			key: 'paused',
			value: function paused() {
				var _ = this;

				if (!_.video) {
					return null;
				}

				return _.video.paused;
			}

			/**
    * Play the video.
    * @return {self} 
    */

		}, {
			key: 'play',
			value: function play() {
				var _ = this;

				if (_.video) {
					_.video.play();
				}

				return _;
			}

			/**
    * Toggle the video between play and pause.
    * @return {self}
    */

		}, {
			key: 'toggle',
			value: function toggle() {
				var _ = this;

				if (_.video) {
					if (_.paused()) {
						_.play();
					} else {
						_.pause();
					}
				}

				return _;
			}

			/**
    * Stop the video and rewind it back to the start.
    * @return {self} 
    */

		}, {
			key: 'rewind',
			value: function rewind() {
				var _ = this;

				if (_.video) {
					_.pause();
					_.video.currentTime = 0;
				}

				return _;
			}
		}]);

		return VideoController;
	}();

	window.VideoController = VideoController;
})(jQuery, window, document);
// Custom body container, Scroll handler and restorer

(function ($, window, document, undefined) {

	var $scrollContainer = $('.js-main-scroll-container'),
	    $sections = $scrollContainer.find('.js-section'),
	    scrollPosition = $scrollContainer.scrollTop(),
	    scrollSpyThreshold = 0.6;

	if (!$('body').hasClass('home')) {
		// Save scroll position before unload
		window.onbeforeunload = function () {
			localStorage.setItem('scrollPosition', $scrollContainer.scrollTop());
			localStorage.setItem('scrollPage', window.location);
		};

		// Restore scroll position on load
		$(document).ready(function () {
			var scrollPosition = localStorage.getItem('scrollPosition'),
			    scrollPage = localStorage.getItem('scrollPage');

			localStorage.removeItem('scrollPosition');
			localStorage.removeItem('scrollPage');

			if (window.location == scrollPage && null !== scrollPosition) {
				$scrollContainer.scrollTop(scrollPosition);
			}
		});
	}

	function getSectionInDirection(direction) {
		var _$section = null;

		$sections.each(function (index, section) {
			var $section = $(section);

			// Get the 1st section whose top edge is on screen
			if (null === _$section && ($section.offset().top + $scrollContainer.scrollTop()).toFixed(0) >= $scrollContainer.scrollTop()) {

				if (direction >= 0) {
					// Scrolling down - return that section
					_$section = $section;
				} else {
					// Scrolling up - return the section directly before that one
					_$section = $sections.eq(Math.max(index - 1, 0));
				}
			}
		});

		if (null === _$section) {
			_$section = $sections.last();
		}

		return _$section;
	}

	function scrollSpySections() {
		var _scrollPosition = $scrollContainer.scrollTop(),

		// Get scroll delta, > 0 down, < 0 up
		delta = _scrollPosition - scrollPosition,
		    $section = getSectionInDirection(delta),
		    sectionName = void 0;

		if ($section.length) {
			sectionName = $section.attr('data-section-name') ? $section.attr('data-section-name') : $section.attr('id');

			sectionName = '#' + sectionName.replace(/ /g, "-");

			if (location.hash !== sectionName && percentInViewport($section) >= scrollSpyThreshold) {
				if (history.pushState) {
					try {
						history.replaceState(null, null, sectionName);
					} catch (e) {
						if (window.console) {
							console.warn("Warning: Page must be hosted to manipulate the hash value.");
						}
					}
				} else {
					window.location.hash = sectionName;
				}
			}

			scrollPosition = _scrollPosition;
		}
	}

	$scrollContainer.scroll(throttle(function (event) {
		scrollSpySections();
	}, 150));
})(jQuery, window, document);
// Initialise carousel components

(function ($, window, document, undefined) {

	var $carousel = $('.js-carousel'),
	    options = {
		autoplay: true,
		autoplaySpeed: 3000,
		pauseOnHover: true,
		dots: true,
		arrows: false,
		infinite: true,
		adaptiveHeight: false,
		draggable: true
	};

	if ($carousel.length) {
		$carousel.slick(options);
	}
})(jQuery, window, document);
// Initialise the scrollify plugin

(function ($, window, document, undefined) {

	var scrollifyController = function () {

		var _isInitialised = false,
		    minBreakpoint = 1023,
		    currentIndex = 0,
		    instance = void 0;

		function init() {
			if (_shouldInit()) {

				var $scrollSections = $('.js-scrolljacked-panel, .js-scrolljacked-interstitial');

				if ($scrollSections.length && $.scrollify) {

					$scrollSections.each(function (id, section) {
						var $section = $(section);

						$section.attr('data-section-name', $section.attr('id'));
						$section.removeAttr('id');
					});

					instance = $.scrollify({
						section: '.js-scrolljacked-panel',
						interstitialSection: '.js-scrolljacked-interstitial',
						target: '.js-main-scroll-container',
						disableSnapAfter: 3,
						standardScrollElements: ".js-header-inner.is-overflown, .j-message",
						afterRender: function afterRender() {
							createDots();

							currentIndex = $.scrollify.currentIndex();

							loadVideo(currentIndex);
							updateDots(currentIndex);

							// Adapter callback into event
							$(document).trigger('scrollify-after-render');
						},
						before: function before(index, elements) {
							loadVideo(index);
							updateDots(index);

							// Adapter callback into event
							$(document).trigger('scrollify-before-move', [index, elements]);
						},
						after: function after(index, elements) {
							var delta = index - currentIndex;

							if (index !== currentIndex) {
								pauseVideo(currentIndex);
							} else {
								loadVideo(index);
							}

							currentIndex = index;

							updateDots(index);

							// Adapter callback into event
							$(document).trigger('scrollify-after-move', [index, elements]);
						}
					});
				}

				$('body').addClass('scrollify-initialised');
				_isInitialised = true;
			}
		}

		function _shouldInit() {
			return $('body').hasClass('home');
		}

		function destroy() {
			if (_isInitialised) {

				$.scrollify.destroy();
				destroyDots();

				$('body').removeClass('scrollify-initialised');

				instance = null;
				_isInitialised = false;
			}
		}

		function update() {
			if (_isInitialised) {

				if (windowWidth() <= minBreakpoint) {
					// Initialised & under min breakpoint
					destroy();

					$('[data-video]').each(function (index, section) {
						section.videoController = null;
						$(section).find('video').remove();
					});
				} else {
					// Initialised & over min breakpoint
					$.scrollify.update();
				}
			} else {

				if (windowWidth() > minBreakpoint) {
					// Not initialised & over min breakpoint
					init();
				}
			}
		}

		function loadVideo(index) {
			var $element = $.scrollify.elements()[index],
			    $videoWrapper = $element.find('[data-video]');

			if ($videoWrapper.length) {
				if (!$videoWrapper.get(0).videoController) {
					$videoWrapper.get(0).videoController = new VideoController($videoWrapper);
				} else {
					$videoWrapper.get(0).videoController.play();
				}
			}
		}

		function pauseVideo(index) {
			var $element = $.scrollify.elements()[index],
			    $videoWrapper = $element.find('[data-video]');

			if ($videoWrapper.length) {
				$videoWrapper.get(0).videoController.rewind();
			}
		}

		function createDots() {
			var $panels = $('.js-scrolljacked-panel'),
			    dots = '<ul class="scrolljacked-panels-dots js-scrollify-dots">';

			$panels.each(function (index, panel) {
				var $panel = $(panel),
				    panelName = $panel.data('name');

				dots += '<li>';

				dots += '<button class="scrolljacked-panels-dots__button js-scrollify-dot" type="button" data-index="' + index + '" data-name="' + panelName + '" aria-labelledby="scrolljacked-dot-label-' + index + '">';
				dots += '&nbsp;';
				dots += '</button>';

				dots += '<span class="scrolljacked-panels-dots__tooltip" id="scrolljacked-dot-label-' + index + '" tabindex="-1">' + panelName + '</span>';

				dots += '</li>';
			});

			dots += '</ul>';

			$('.js-scrollify-container').append($(dots));

			$(document).on('click.scrollifyDot', '.js-scrollify-dot', function (event) {
				var $target = $(event.target);

				if (!$target.is('.js-scrollify-dot')) {
					$target = $target.closest('.js-scrollify-dot');
				}

				$.scrollify.move($target.data('index'), true);
				updateDots($target.data('index'));
			});
		}

		function updateDots(index) {
			var $dots = $('.js-scrollify-dots');

			$dots.children('.is-active').removeClass('is-active');
			$dots.children().eq(index).addClass('is-active');
		}

		function destroyDots() {
			var $dots = $('.js-scrollify-dots');

			if ($dots.length) {
				$dots.remove();
			}
		}

		$(window).on('resize', debounce(update, 150));
		update();

		return {
			isInitialised: function isInitialised() {
				// Needs to be function to dynamically update the value when the local var changes
				return _isInitialised;
			},
			update: update
		};
	}();

	window.scrollifyController = scrollifyController;
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Run when Juicer feed has loaded

(function ($, window, document, undefined) {

	var JuicerFeedController = function () {
		function JuicerFeedController() {
			_classCallCheck(this, JuicerFeedController);

			var _ = this;
		}

		_createClass(JuicerFeedController, [{
			key: 'run',
			value: function run() {
				var _ = this;

				// Manifest of tasks to run
				_._bindTouchEvents();
				_._matchButtonsStyle();
				_._fixBrokenImages();
				// If object-fit isn't supported, use backgrounds instead.
				if (!Modernizr.objectfit) {
					_._mapImagesToBackgrounds();
				}

				// Ensure Scrollify has the right height for the section
				// A lot of stuff just got loaded
				if ($.scrollify) {
					$.scrollify.update();
				}
			}

			/**
    * Add touch events to show hover state.
    */

		}, {
			key: '_bindTouchEvents',
			value: function _bindTouchEvents() {
				var _ = this,
				    $feed = $('.juicer-feed'),
				    hoverClass = 'has-hover';

				// DEBUG: Enable this if you want to see all hover states at once
				// $feed.find('li.feed-item').addClass(hoverClass);

				$feed.on('touchstart', function (event) {
					var $target = $(event.target),
					    $activeItems = $('.juicer-feed li.feed-item.' + hoverClass);

					if (!$target.is('li.feed-item')) {
						$target = $target.closest('li.feed-item');
					}

					// If still not correct item, exit early
					if (!$target.is('li.feed-item')) {
						$activeItems.removeClass(hoverClass);
						return;
					}

					$activeItems.removeClass(hoverClass);
					$target.addClass(hoverClass);
				});
			}

			/**
    * Match the Juicer button style to the style of the website.
    */

		}, {
			key: '_matchButtonsStyle',
			value: function _matchButtonsStyle() {
				var $juicerButton = $('.juicer-button');

				$juicerButton.html('<span>' + $juicerButton.html() + '</span>');
			}

			/**
    * Listen for image load errors and add a fallback class.
    */

		}, {
			key: '_fixBrokenImages',
			value: function _fixBrokenImages() {
				var _ = this,
				    $feed = $('.juicer-feed'),
				    defaultImageSrc = wp.stylesheet_directory_uri + '/dist/images/social-profile.jpg';

				// Turn off existing events to prevent overlap
				$feed.find('.j-poster img').off('error.Juicer');

				$feed.find('.j-poster img').on('error', function (event) {
					var $target = $(event.target);

					if (!$target.is('img')) {
						$target = $target.closest('img');
					}

					$target.attr('src', defaultImageSrc);
				});
			}

			/**
    * If object-fit isn't supported, hide img tags and 
    * use the source as a background image instead.
    * This lets us mimic object-fit with background-size.
    */

		}, {
			key: '_mapImagesToBackgrounds',
			value: function _mapImagesToBackgrounds() {
				var $imagePosts = $('.j-instagram, .j-twitter.image-post, .j-facebook.image-post, .j-video');

				$imagePosts.each(function (index, post) {
					var $post = $(post),
					    $image = $post.find('.j-image');

					$image.css({
						"background-image": 'url("' + $image.find('img').attr('src') + '")'
					});
					$image.find('img').css({
						"visibility": "hidden"
					});
				});
			}
		}]);

		return JuicerFeedController;
	}();

	var onJuicerLoaded = function onJuicerLoaded() {
		var _juicerFeedController = new JuicerFeedController();
		_juicerFeedController.run();
	};

	/**
  * Not loaded into Dispatcher as Juicer calls this
  * particlular function when it loads.
  * @type {Function}
  */
	window.onJuicerLoaded = onJuicerLoaded;
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Navigation Controller

(function ($, window, document, undefined) {

	var NavigationController = function () {
		function NavigationController() {
			_classCallCheck(this, NavigationController);

			var _ = this;

			_.$button = $('.js-menu-toggle');

			_.openClass = 'menu-is-open';
			_.openingClass = 'menu-is-opening';
			_.closingClass = 'menu-is-closing';

			_.duration = 300;

			_.navigationMaxBreakpoint = 1399;

			_._bindEvents();
		}

		/**
   * Add event handlers needed by this class.
   * @return {self} 
   */


		_createClass(NavigationController, [{
			key: '_bindEvents',
			value: function _bindEvents() {
				var _ = this;

				$('.js-header-shade').on('click', function (event) {
					if (_.isOpen()) {
						_.close();
					}
				});

				_.$button.on('click', function (event) {
					_.toggle();

					event.preventDefault();
					return false;
				});

				$(document).on('keydown', function (event) {
					var escKeyCode = 27;

					if (escKeyCode === event.keyCode && _.isOpen()) {
						_.close();
					}
				});

				return _;
			}

			/**
    * Check if the navigation drawer is open.
    * @return {Boolean}
    */

		}, {
			key: 'isOpen',
			value: function isOpen() {
				var _ = this;

				if (windowWidth() > _.navigationMaxBreakpoint) {
					// Above this width the drawer is always open
					return true;
				}

				return $('body').hasClass(_.openClass);
			}

			/**
    * Open the navigation drawer.
    * @return {self}]
    */

		}, {
			key: 'open',
			value: function open() {
				var _ = this;

				// Stop the body from being able to scroll
				window.ViewportScroll.disable();

				$('body').removeClass(_.closingClass);
				$('body').addClass(_.openingClass);

				$('body').addClass(_.openClass);

				setTimeout(function () {
					$('body').removeClass(_.openingClass);
				}, _.duration);

				return _;
			}

			/**
    * Close the navigation drawer.
    * @return {self} 
    */

		}, {
			key: 'close',
			value: function close() {
				var _ = this;

				// Restore the body scroll functionality
				window.ViewportScroll.enable();

				$('body').removeClass(_.openingClass);
				$('body').addClass(_.closingClass);

				$('body').removeClass(_.openClass);

				setTimeout(function () {
					$('body').removeClass(_.closingClass);
				}, _.duration);

				return _;
			}

			/**
    * Open/Close the navigation drawer.
    * @return {self} 
    */

		}, {
			key: 'toggle',
			value: function toggle() {
				var _ = this;

				if (_.isOpen()) {
					_.close();
				} else {
					_.open();
				}

				return _;
			}
		}]);

		return NavigationController;
	}();

	var _navigationController = new NavigationController();

	window.navigationController = _navigationController;
})(jQuery, window, document);
// Newsletter Form Handler

(function ($, window, document, undefined) {

  var $newsletterForm = $('#newsletter-sign-up');

  if ($newsletterForm.length) {
    var _newsletterFormController = new NewsletterFormController($newsletterForm);

    // Stop the browser showing it's default error handling UI, only when the JS has loaded
    $newsletterForm.attr('novalidate', 'true');

    // Listen for bubbled events from button
    // Submit events fire default HTML5 validation as well
    $newsletterForm.find('#newsletter_submit').on('click', function (event) {

      if (!_newsletterFormController.validate()) {

        // Scroll to and focus first error
        var errorFound = false;
        $.each(_newsletterFormController.fields, function (index, field) {
          if (field.hasError && !errorFound) {
            // Force offset so that whole form element is showing
            window.SmoothScroll.setTempOffset(-100).toElement(field.$field).restoreOffset();
            field.$field.focus();

            errorFound = true;
          }
        });

        event.preventDefault();
        return false;
      }
    });

    $newsletterForm.on('submit', function (event) {
      $newsletterForm.find('#newsletter_submit').html('Sending&hellip;');
    });
  }

  // Listen for change events and hide field errors
  $newsletterForm.find('input, textarea, select').on('change', function (event) {
    var $this = $(event.target),
        formField = new FormField($this);

    $this.trigger('removeError');
    $this.parent().trigger('removeError');
  });
})(jQuery, window, document);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// SVG Map Controller

(function ($, window, document, undefined) {

	var SVGMapContoller = function () {
		function SVGMapContoller($element) {
			_classCallCheck(this, SVGMapContoller);

			var _ = this;

			_.$element = $element;

			_.$draggableContainer = _.$element.parent();
			_.$container = _.$draggableContainer.parent();

			// Only buildings with an id attribute will have an associated section
			// Since there could be IDs for tenants/lettings areas, filter 
			// to only IDs that have a corresponding details element
			_.$buildings = _.$element.find('[id]').filter(function (index, building) {
				var $tenant = _._getTenant($(building).attr('id'));

				return !!$tenant;
			});

			_.$zoomControls = $('.js-svgmap-zoom');
			_.$toggleControls = $('.js-svgmap-toggle');

			// Initial scale as well as being used to maintain current state
			_._scale = 1;
			_._minScale = 0.4;
			_._maxScale = 2;

			_._isBeingDragged = false;

			_._isZooming = false;
			_._zoomInterval = 150;
			_._zoomTimer = null;

			_._bindEvents();
		}

		_createClass(SVGMapContoller, [{
			key: '_getTenant',
			value: function _getTenant(id) {
				var _ = this,
				    $tenant = $('[data-tenant="' + id + '"]');

				if (!$tenant.length) {
					return false;
				}

				return $tenant;
			}
		}, {
			key: '_bindEvents',
			value: function _bindEvents() {
				var _ = this;

				// Make the map container draggable for navigation
				_.$draggableContainer.draggable({
					scroll: false,
					start: function start() {
						_._isBeingDragged = true;
					},
					stop: function stop() {
						_._isBeingDragged = false;
					}
				});

				/**
     * Link up zoom controls so that they keep zooming 
     * if the button is held down.
     * Starts a timer and then zooms in specific increments.
     */
				_.$zoomControls.mousedown(function (event) {
					if (1 == event.which) {
						var $target = $(event.target),
						    amount = void 0;

						if (!$target.is('.js-svgmap-zoom')) {
							$target = $target.closest('.js-svgmap-zoom');
						}

						amount = $target.attr('data-scale');
						_._isZooming = true;

						// Run first call straight away, function recurs
						_.zoom(amount);

						event.preventDefault();
						return false;
					}
				});

				/**
     * Listen for mouseup events to cancel the timer.
     * Listened for events across the document, to prevent
     * the situation where somebody clicks on the button,
     * moves the mouse off, and then releases the button 
     * on a separate element.
     */
				$(document).mouseup(function (event) {
					_._isZooming = false;

					if (null !== _._zoomTimer) {
						clearTimeout(_._zoomTimer);
						_._zoomTimer = null;
					}
				});

				_.$toggleControls.click(function (event) {
					if (1 == event.which) {
						var $event = $(event.target);

						if (!$event.is('.js-svgmap-toggle')) {
							$event = $event.closest('.js-svgmap-toggle');
						}

						var $map = $($event.data('map'));

						if ($map.length) {
							$map.siblings().hide();
							$map.show();

							_.$toggleControls.removeClass('is-active');
							$event.addClass('is-active');
						}

						event.preventDefault();
						return false;
					}
				});

				// On click, show tenants details pane
				_.$buildings.click(function (event) {
					var $target = $(event.target);

					_.showDetails($target);
				});

				return _;
			}
		}, {
			key: '_clearInterval',
			value: function _clearInterval() {
				var _ = this;

				if (null !== _._zoomIntervalID) {
					clearInterval(_._zoomIntervalID);
				}

				return _;
			}
		}, {
			key: 'roundDecimal',
			value: function roundDecimal(value, precision) {
				var multiplier = Math.pow(10, precision || 0);
				return Math.round(value * multiplier) / multiplier;
			}
		}, {
			key: 'zoom',
			value: function zoom(amount) {
				var _ = this,
				    newScale = void 0,
				    transform = void 0;

				if (_._isZooming) {
					newScale = _.roundDecimal(_._scale + parseFloat(amount), 1);

					// Constrain to min and max
					newScale = Math.min(newScale, _._maxScale);
					newScale = Math.max(newScale, _._minScale);

					_._scale = newScale;
					transform = _._getTransform();

					_.$element.css({
						transform: transform
					});

					setTimeout(function () {
						return _.zoom(amount);
					}, _._zoomInterval);
				}

				return _;
			}
		}, {
			key: '_getTransform',
			value: function _getTransform() {
				var _ = this,
				    scaleTransform = 'scale( ' + _._scale + ' )';

				// Return another template literal to allow
				// compound transforms to be built in future
				return '' + scaleTransform;
			}
		}, {
			key: 'showDetails',
			value: function showDetails($building) {
				var _ = this,
				    $target = _._getTenant($building.attr('id'));

				if ($target.length) {
					$('[data-tenant]').hide();
					$target.show();

					if (windowWidth() <= 1023) {
						window.location = $target.find('.button').get(0).href;
					}

					_.$buildings.css('fill', '');

					$building.css('fill', 'red');
				}
			}
		}]);

		return SVGMapContoller;
	}();

	// Expose API
	window.SVGMapContoller = SVGMapContoller;
})(jQuery, window, document);
// Init SVG maps

(function ($, window, document, undefined) {

	var $map = $('#tenants-map'),
	    mapController = void 0;

	if ($map.length) {
		mapController = new SVGMapContoller($map);
	}
})(jQuery, window, document);
// Main initialiser

(function ($, window, document, undefined) {

	(function () {

		/**
   * Scroll to a hash on the page.
   * Will check scrollify named sections if the plugin exists.
   * @param  {String} hash A hash string to scroll to. Should include the # character at the start.
   */
		var scrollToHash = function scrollToHash(hash) {
			// Figure out element to scroll to
			var $target = $(hash);
			$target = $target.length ? $target : $('[name=' + hash.slice(1) + ']');
			// Does a scroll target exist?
			if ($target.length) {
				window.SmoothScroll.toElement($target);
			} else {

				var $altTarget = $('[data-section-name="' + hash.replace(/#/, '') + '"]');

				if ($altTarget.length) {
					if ($('body').hasClass('scrollify-initialised')) {
						$.scrollify.move(hash);
					} else {
						window.SmoothScroll.toElement($altTarget);
					}
				}
			}
		};

		/**
   * Smooth scroll anchors starting with a hash.
   */
		$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]').not('[href="#0"]').click(function (event) {
			// On-page links
			if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
				scrollToHash(this.hash);
			}
		});

		/**
   * Smooth scroll logo to top of page, if on home page
   */
		$('.js-logo').click(function (event) {
			if ($('body').hasClass('home')) {

				if (window.scrollifyController.isInitialised()) {
					// Explicit hash of first section
					scrollToHash('#shopping');
				} else {
					window.SmoothScroll.toPosition(0);
				}

				if (window.navigationController.isOpen()) {
					window.navigationController.close();
				}

				event.preventDefault();
				return false;
			}
		});
	})();

	// Listen for hash changes and act accordingly
	(function () {

		window.onhashchange = function () {
			if (location.hash) {

				if ($('body').hasClass('scrollify-initialised') && $('[data-section-name="' + location.hash.slice(1) + '"]').length) {
					$.scrollify.move(location.hash, true);
				}
			}
		};
	})();

	// Check if navigation has overflow and toggle class
	(function () {
		var $possibleOverflowElements = $('.js-header-inner'),
		    isOverflown = function isOverflown(element) {
			return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
		},
		    setClass = function setClass() {
			if ($possibleOverflowElements.length) {
				$possibleOverflowElements.each(function (index, element) {
					var $element = $(element);
					$element.toggleClass('is-overflown', isOverflown($element.get(0)));
				});
			}
		};

		setClass();
		$(window).resize(setClass);
		$(document).on('menu-drawer-changed-state', setClass);
	})();

	// Toggle submenu drawers within main navigation
	(function () {

		var $drawers = $('.js-menu-drawer');

		var DrawerEventController = function () {

			/**
    * Get (or create) the singleton controller for a drawer.
    * The class will be stored onto the element.
    * @param  {jQuery} $drawer A jQuery element represeting a menu drawer.
    * @return {MenuDrawerController}
    */
			function _getController($drawer) {
				var controller = void 0;

				if ($drawer.get(0).drawerController) {
					controller = $drawer.get(0).drawerController;
				} else {
					controller = new MenuDrawerController($drawer, $drawer.find('.js-menu-drawer__toggle'), $drawer.find('.submenu'));
					$drawer.get(0).drawerController = controller;
				}

				return controller;
			}

			/**
    * Close the currently open (active) drawer.
    */
			function closeActive() {
				var $activeDrawer = $drawers.filter('.is-open'),
				    drawerController = void 0;

				if ($activeDrawer.length) {
					drawerController = _getController($activeDrawer);
					drawerController.close();
				}
			}

			/**
    * Open a specific drawer.
    * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
    */
			function open($drawer) {
				var drawerController = _getController($drawer);

				drawerController.open();
			}

			/**
    * Close a specific drawer.
    * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
    */
			function close($drawer) {
				var drawerController = _getController($drawer);

				drawerController.close();
			}

			/**
    * Open or close a specific drawer.
    * @param  {jQuery} $drawer a jQuery element represeting a menu drawer.
    */
			function toggle($drawer) {
				var drawerController = _getController($drawer);

				drawerController.toggle();
			}

			return {
				closeActive: closeActive,
				open: open,
				close: close,
				toggle: toggle
			};
		}();

		$('.js-menu-drawer__toggle').click(function (event) {

			var $target = $(event.target);

			if (!$target.is('.js-menu-drawer__toggle')) {
				$target = $target.closest('.js-menu-drawer__toggle');
			}

			DrawerEventController.closeActive();
			DrawerEventController.toggle($target.closest('.js-menu-drawer'));
		});
	})();

	// Handle clicks on tenants and filters
	(function () {

		var $tenants = $('.js-tenant'),
		    $filters = $('.js-filter-button');
		var supportsHistory = !!(window.history && window.history.pushState);

		if (!$tenants.length || !$filters.length) {
			return;
		}

		function disableActive() {
			$tenants.filter('.is-active').removeClass('is-active').find('.tenant-grid-item__image').css('transform', '');
		}

		$tenants.on('click mouseover', function (event) {
			var $this = $(event.target);

			if (!$this.is('.js-tenant')) {
				$this = $this.closest('.js-tenant');
			}

			disableActive();
			$this.addClass('is-active');

			var transform = 'translateY(-125px) translateY(50%) translateY(1em)';
			$image = $this.find('.tenant-grid-item__image');

			transform += 'scale( ' + 70 / $image.outerHeight() + ' )';
			$image.css('transform', transform);
		});

		$tenants.on('mouseout', function (event) {
			disableActive();
		});

		function filterTenants(value) {
			if ('*' == value) {
				$tenants.show();
			} else {

				var $items = $('.js-tenant[data-term="' + value + '"]');

				if ($items.length) {
					$tenants.hide();
					$items.show();
				}
			}

			if (supportsHistory) {
				var pageUrl = getPageUrl();
				var url = addQueryArg('filter', value, pageUrl);

				if (pageUrl !== url) {
					window.history.pushState({ path: url }, '', url);
				}
			}
		}

		$filters.click(function (event) {
			var $this = $(event.target);
			var filter = $this.data('filter');

			filterTenants(filter);
		});

		var onLoadFilter = getQueryArg(location.href, 'filter');
		if (onLoadFilter) {
			filterTenants(onLoadFilter);
		}

		if (supportsHistory) {
			window.onpopstate = function (event) {
				var filter = getQueryArg(location.href, 'filter');

				if (filter) {
					filterTenants(filter);
				}
			};

			// Replace current page state on load with show all search
			if (!onLoadFilter) {
				var url = addQueryArg('filter', '*', getPageUrl());
				window.history.replaceState({ path: url }, '', url);
			}
		}
	})();

	// Fix object-fit display in non-supporting browsers
	(function () {

		var $objectFitImages = $('.polyfill-object-fit');

		if ($objectFitImages.length && !Modernizr.objectfit) {
			$objectFitImages.each(function (index, img) {
				var $img = $(img);

				$img.wrap('<div style="background-image: url(' + $img.attr('src') + ');"></div>');
				$img.parent().attr('class', $img.attr('class'));
				$img.removeAttr('class');

				$img.css({
					visibility: 'hidden'
				});
			});
		}
	})();

	// Set up match height plugin, only for IE
	(function () {

		if (device.isIE) {
			$('[data-ie-mh]').matchHeight();
			if (window.scrollifyController) {
				window.scrollifyController.update();
			}
		}
	})();

	// Handle clicks to surface the search form if hidden within the menu
	(function () {

		var $searchTriggers = $('.js-show-search-form'),
		    $searchForm = $('#search-form');

		$searchTriggers.click(function (event) {
			if ($searchForm.length) {
				if (navigationController.isOpen()) {
					$searchForm.find('input').focus();
					$searchForm.addClass('seek-attention');
				} else {
					navigationController.open();

					setTimeout(function () {
						$searchForm.find('input').focus();
					}, 450);
				}

				setTimeout(function () {
					$searchForm.removeClass('seek-attention');
				}, 1000);
			}

			event.preventDefault();
			return false;
		});
	})();
})(jQuery, window, document);